/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Product Emissions Forecaster
 * OpenAPI spec version: 3.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  AccordionsViewModel,
  AlertDetailsViewModel,
  AlertRequest,
  AlertStatusUpdate,
  BodyCreateIssueIssuesPost,
  BodyStartIngestFullIngestFullPost,
  BodyStartIngestNumericalIngestNumericalPost,
  BodyUploadBulkUserMembersUploadPost,
  BulkMemberPermissionsModel,
  CategoryDlzShare,
  CategoryMixAggregatedRequest,
  CategoryPackMix,
  CategoryViewModel,
  CdeAggregatedRequest,
  CdeEnergyMixEfMacroAdjustmentDto,
  CdeFleetBreakdownAggregatedRequest,
  CdeFleetBreakdownMacroAdjustmentDto,
  CountryAverageDistanceTravelled,
  CountryAverageManufacturingEur,
  CountryCdeAverageEnergyConsumption,
  CountryCdeEnergyEmissionFactor,
  CountryPackagingAverageRecoveryRate,
  CountrySalesGrowth,
  CountryViewModel,
  CreateMemberModel,
  CreateMicroAdjustment,
  DataExtractRequest,
  DlzShareAggregatedRequest,
  EditMacroScenarioAdjustment,
  EditMemberModel,
  EditMicroAdjustment,
  EditMicroScenarioProductDto,
  EmissionFactorRequest,
  EnergyTypeEmissionFactor,
  EntityWeightAggregate,
  FunctionalAreaItemViewModel,
  GetAlertDetailsForAdminPanelAlertsGet200,
  GetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet200,
  GetDataManagementNumericDataDataManagementExportAvailableDataNumericGet200,
  GetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetParams,
  GetSkusSkusGetParams,
  GetTotalRtdlScenariosMacroTotalRtdlGetParams,
  GumCountryViewModel,
  HTTPValidationError,
  IngestViewModel,
  IngredientEmissionFactor,
  IngredientEmissionFactorMacroAdjustmentDto,
  IngredientMultiWeightMacroAdjustmentDto,
  IngredientSpecificWeightMacroAdjustmentDto,
  IngredientWeightAggregatedRequest,
  LegalPolicyViewModel,
  ListMacroScenarioDto,
  ListMicroScenarioDto,
  LogisticsDistanceMacroAdjustmentDto,
  LogisticsOtherVehicleMixEfMacroAdjustmentDto,
  LogisticsRoadVehicleMixEfMacroAdjustmentDto,
  MacroAdjustmentPosition,
  MacroFiltersAndFilteredRTDL,
  MacroFiltersAndFilteredRTDLForProducts,
  MacroScenarioAdjustmentOverview,
  MacroScenarioFilterView,
  ManufacturingEurMacroAdjustmentDto,
  ManufacturingSourceMixEfMacroAdjustmentDto,
  MemberDetails,
  Metadata,
  PackMixAggregatedRequest,
  PackTypeViewModel,
  PackagingEmissionFactorMacroAdjustmentDto,
  PackagingMultiWeightMacroAdjustmentDto,
  PackagingNetLossRateMacroAdjustmentDto,
  PackagingRecoveryRateMacroAdjustmentDto,
  PackagingRecycledContentMacroAdjustmentDto,
  PackagingSpecificWeightMacroAdjustmentDto,
  PackagingWeightAggregatedRequest,
  PartMaterialEmissionFactor,
  Product,
  ProductsAggregatedRequest,
  SKUMinimalViewModel,
  SKUProductPosition,
  SalesGrowthAggregatedRequest,
  SalesMixCategoryMixMacroAdjustmentDto,
  SalesMixDlzShareMacroAdjustmentDto,
  SalesMixPackMixMacroAdjustmentDto,
  SalesMixSalesGrowthMacroAdjustmentDto,
  TermsAndConditionsStatusViewModel,
  UpdateMacroScenarioDto,
  UpdateScenarioValues,
  VehicleMixEmissionFactor,
  ViewMacroScenarioAdjustment,
  ViewMacroScenarioDto,
  ViewMicroAdjustment,
  ViewMicroScenarioDto,
  WeightedAverageNetLossRateAggregate,
  WeightedAverageRecycledContentAggregate,
  YearCategoryMix,
  YearViewModel,
} from "./models";
import { withCustomAxios } from "../mutator/custom-instance";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary Get Info For App Service
 */
export const getInfoForAppServiceInfoGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<unknown>({ url: `/info`, method: "GET" }, options);
};

export const getGetInfoForAppServiceInfoGetQueryKey = () => {
  return [`/info`] as const;
};

export const getGetInfoForAppServiceInfoGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInfoForAppServiceInfoGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>
  > = () => getInfoForAppServiceInfoGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetInfoForAppServiceInfoGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>
>;
export type GetInfoForAppServiceInfoGetQueryError = unknown;

export function useGetInfoForAppServiceInfoGet<
  TData = Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInfoForAppServiceInfoGet<
  TData = Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInfoForAppServiceInfoGet<
  TData = Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Info For App Service
 */

export function useGetInfoForAppServiceInfoGet<
  TData = Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getInfoForAppServiceInfoGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetInfoForAppServiceInfoGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Root For App Service
 */
export const getRootForAppServiceGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<unknown>({ url: `/`, method: "GET" }, options);
};

export const getGetRootForAppServiceGetQueryKey = () => {
  return [`/`] as const;
};

export const getGetRootForAppServiceGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getRootForAppServiceGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRootForAppServiceGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRootForAppServiceGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRootForAppServiceGet>>
  > = () => getRootForAppServiceGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRootForAppServiceGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRootForAppServiceGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRootForAppServiceGet>>
>;
export type GetRootForAppServiceGetQueryError = unknown;

export function useGetRootForAppServiceGet<
  TData = Awaited<ReturnType<typeof getRootForAppServiceGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRootForAppServiceGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getRootForAppServiceGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRootForAppServiceGet<
  TData = Awaited<ReturnType<typeof getRootForAppServiceGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRootForAppServiceGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getRootForAppServiceGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRootForAppServiceGet<
  TData = Awaited<ReturnType<typeof getRootForAppServiceGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRootForAppServiceGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Root For App Service
 */

export function useGetRootForAppServiceGet<
  TData = Awaited<ReturnType<typeof getRootForAppServiceGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRootForAppServiceGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRootForAppServiceGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Skus
 */
export const getSkusSkusGet = (
  params?: GetSkusSkusGetParams,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<SKUMinimalViewModel[]>(
    { url: `/skus`, method: "GET", params },
    options,
  );
};

export const getGetSkusSkusGetQueryKey = (params?: GetSkusSkusGetParams) => {
  return [`/skus`, ...(params ? [params] : [])] as const;
};

export const getGetSkusSkusGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getSkusSkusGet>>,
  TError = HTTPValidationError,
>(
  params?: GetSkusSkusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSkusSkusGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSkusSkusGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSkusSkusGet>>
  > = () => getSkusSkusGet(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSkusSkusGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSkusSkusGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSkusSkusGet>>
>;
export type GetSkusSkusGetQueryError = HTTPValidationError;

export function useGetSkusSkusGet<
  TData = Awaited<ReturnType<typeof getSkusSkusGet>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetSkusSkusGetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSkusSkusGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSkusSkusGet>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSkusSkusGet<
  TData = Awaited<ReturnType<typeof getSkusSkusGet>>,
  TError = HTTPValidationError,
>(
  params?: GetSkusSkusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSkusSkusGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSkusSkusGet>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSkusSkusGet<
  TData = Awaited<ReturnType<typeof getSkusSkusGet>>,
  TError = HTTPValidationError,
>(
  params?: GetSkusSkusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSkusSkusGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Skus
 */

export function useGetSkusSkusGet<
  TData = Awaited<ReturnType<typeof getSkusSkusGet>>,
  TError = HTTPValidationError,
>(
  params?: GetSkusSkusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSkusSkusGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSkusSkusGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Years
 */
export const getYearsYearsGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<YearViewModel[]>(
    { url: `/years`, method: "GET" },
    options,
  );
};

export const getGetYearsYearsGetQueryKey = () => {
  return [`/years`] as const;
};

export const getGetYearsYearsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getYearsYearsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getYearsYearsGet>>, TError, TData>
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetYearsYearsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getYearsYearsGet>>
  > = () => getYearsYearsGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getYearsYearsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetYearsYearsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getYearsYearsGet>>
>;
export type GetYearsYearsGetQueryError = unknown;

export function useGetYearsYearsGet<
  TData = Awaited<ReturnType<typeof getYearsYearsGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getYearsYearsGet>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getYearsYearsGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetYearsYearsGet<
  TData = Awaited<ReturnType<typeof getYearsYearsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getYearsYearsGet>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getYearsYearsGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetYearsYearsGet<
  TData = Awaited<ReturnType<typeof getYearsYearsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getYearsYearsGet>>, TError, TData>
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Years
 */

export function useGetYearsYearsGet<
  TData = Awaited<ReturnType<typeof getYearsYearsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getYearsYearsGet>>, TError, TData>
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetYearsYearsGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Gum Territories
 */
export const getGumTerritoriesTerritoriesGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<GumCountryViewModel[]>(
    { url: `/territories`, method: "GET" },
    options,
  );
};

export const getGetGumTerritoriesTerritoriesGetQueryKey = () => {
  return [`/territories`] as const;
};

export const getGetGumTerritoriesTerritoriesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGumTerritoriesTerritoriesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>
  > = () => getGumTerritoriesTerritoriesGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetGumTerritoriesTerritoriesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>
>;
export type GetGumTerritoriesTerritoriesGetQueryError = unknown;

export function useGetGumTerritoriesTerritoriesGet<
  TData = Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGumTerritoriesTerritoriesGet<
  TData = Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGumTerritoriesTerritoriesGet<
  TData = Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Gum Territories
 */

export function useGetGumTerritoriesTerritoriesGet<
  TData = Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGumTerritoriesTerritoriesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetGumTerritoriesTerritoriesGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Start Ingest Full
 */
export const startIngestFullIngestFullPost = (
  bodyStartIngestFullIngestFullPost: BodyStartIngestFullIngestFullPost,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  const formData = new FormData();
  formData.append("zip", bodyStartIngestFullIngestFullPost.zip);

  return withCustomAxios<IngestViewModel>(
    {
      url: `/ingest/full`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getStartIngestFullIngestFullPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startIngestFullIngestFullPost>>,
    TError,
    { data: BodyStartIngestFullIngestFullPost },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startIngestFullIngestFullPost>>,
  TError,
  { data: BodyStartIngestFullIngestFullPost },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startIngestFullIngestFullPost>>,
    { data: BodyStartIngestFullIngestFullPost }
  > = (props) => {
    const { data } = props ?? {};

    return startIngestFullIngestFullPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartIngestFullIngestFullPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof startIngestFullIngestFullPost>>
>;
export type StartIngestFullIngestFullPostMutationBody =
  BodyStartIngestFullIngestFullPost;
export type StartIngestFullIngestFullPostMutationError = HTTPValidationError;

/**
 * @summary Start Ingest Full
 */
export const useStartIngestFullIngestFullPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startIngestFullIngestFullPost>>,
    TError,
    { data: BodyStartIngestFullIngestFullPost },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startIngestFullIngestFullPost>>,
  TError,
  { data: BodyStartIngestFullIngestFullPost },
  TContext
> => {
  const mutationOptions =
    getStartIngestFullIngestFullPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Start Ingest Numerical
 */
export const startIngestNumericalIngestNumericalPost = (
  bodyStartIngestNumericalIngestNumericalPost: BodyStartIngestNumericalIngestNumericalPost,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  const formData = new FormData();
  formData.append("zip", bodyStartIngestNumericalIngestNumericalPost.zip);

  return withCustomAxios<IngestViewModel>(
    {
      url: `/ingest/numerical`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getStartIngestNumericalIngestNumericalPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startIngestNumericalIngestNumericalPost>>,
    TError,
    { data: BodyStartIngestNumericalIngestNumericalPost },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startIngestNumericalIngestNumericalPost>>,
  TError,
  { data: BodyStartIngestNumericalIngestNumericalPost },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startIngestNumericalIngestNumericalPost>>,
    { data: BodyStartIngestNumericalIngestNumericalPost }
  > = (props) => {
    const { data } = props ?? {};

    return startIngestNumericalIngestNumericalPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartIngestNumericalIngestNumericalPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof startIngestNumericalIngestNumericalPost>>
>;
export type StartIngestNumericalIngestNumericalPostMutationBody =
  BodyStartIngestNumericalIngestNumericalPost;
export type StartIngestNumericalIngestNumericalPostMutationError =
  HTTPValidationError;

/**
 * @summary Start Ingest Numerical
 */
export const useStartIngestNumericalIngestNumericalPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startIngestNumericalIngestNumericalPost>>,
    TError,
    { data: BodyStartIngestNumericalIngestNumericalPost },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startIngestNumericalIngestNumericalPost>>,
  TError,
  { data: BodyStartIngestNumericalIngestNumericalPost },
  TContext
> => {
  const mutationOptions =
    getStartIngestNumericalIngestNumericalPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Ingest Status Route
 */
export const getIngestStatusRouteIngestIngestIdGet = (
  ingestId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<IngestViewModel>(
    { url: `/ingest/${ingestId}`, method: "GET" },
    options,
  );
};

export const getGetIngestStatusRouteIngestIngestIdGetQueryKey = (
  ingestId: number,
) => {
  return [`/ingest/${ingestId}`] as const;
};

export const getGetIngestStatusRouteIngestIngestIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
  TError = HTTPValidationError,
>(
  ingestId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIngestStatusRouteIngestIngestIdGetQueryKey(ingestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>
  > = () => getIngestStatusRouteIngestIngestIdGet(ingestId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!ingestId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIngestStatusRouteIngestIngestIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>
>;
export type GetIngestStatusRouteIngestIngestIdGetQueryError =
  HTTPValidationError;

export function useGetIngestStatusRouteIngestIngestIdGet<
  TData = Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
  TError = HTTPValidationError,
>(
  ingestId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIngestStatusRouteIngestIngestIdGet<
  TData = Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
  TError = HTTPValidationError,
>(
  ingestId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIngestStatusRouteIngestIngestIdGet<
  TData = Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
  TError = HTTPValidationError,
>(
  ingestId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Ingest Status Route
 */

export function useGetIngestStatusRouteIngestIngestIdGet<
  TData = Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
  TError = HTTPValidationError,
>(
  ingestId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIngestStatusRouteIngestIngestIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetIngestStatusRouteIngestIngestIdGetQueryOptions(
    ingestId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get App Info
 */
export const getAppInfoMetadataGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<Metadata>(
    { url: `/metadata`, method: "GET" },
    options,
  );
};

export const getGetAppInfoMetadataGetQueryKey = () => {
  return [`/metadata`] as const;
};

export const getGetAppInfoMetadataGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppInfoMetadataGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAppInfoMetadataGet>>
  > = () => getAppInfoMetadataGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAppInfoMetadataGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAppInfoMetadataGet>>
>;
export type GetAppInfoMetadataGetQueryError = unknown;

export function useGetAppInfoMetadataGet<
  TData = Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAppInfoMetadataGet<
  TData = Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAppInfoMetadataGet<
  TData = Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get App Info
 */

export function useGetAppInfoMetadataGet<
  TData = Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAppInfoMetadataGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAppInfoMetadataGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Privacy Policy
 */
export const getPrivacyPolicyLegalPrivacyStatementGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<LegalPolicyViewModel>(
    { url: `/legal/privacy-statement`, method: "GET" },
    options,
  );
};

export const getGetPrivacyPolicyLegalPrivacyStatementGetQueryKey = () => {
  return [`/legal/privacy-statement`] as const;
};

export const getGetPrivacyPolicyLegalPrivacyStatementGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPrivacyPolicyLegalPrivacyStatementGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>
  > = () => getPrivacyPolicyLegalPrivacyStatementGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPrivacyPolicyLegalPrivacyStatementGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>
>;
export type GetPrivacyPolicyLegalPrivacyStatementGetQueryError = unknown;

export function useGetPrivacyPolicyLegalPrivacyStatementGet<
  TData = Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPrivacyPolicyLegalPrivacyStatementGet<
  TData = Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPrivacyPolicyLegalPrivacyStatementGet<
  TData = Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Privacy Policy
 */

export function useGetPrivacyPolicyLegalPrivacyStatementGet<
  TData = Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPrivacyPolicyLegalPrivacyStatementGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPrivacyPolicyLegalPrivacyStatementGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Cookies Policy
 */
export const getCookiesPolicyLegalCookieStatementGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<LegalPolicyViewModel>(
    { url: `/legal/cookie-statement`, method: "GET" },
    options,
  );
};

export const getGetCookiesPolicyLegalCookieStatementGetQueryKey = () => {
  return [`/legal/cookie-statement`] as const;
};

export const getGetCookiesPolicyLegalCookieStatementGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCookiesPolicyLegalCookieStatementGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>
  > = () => getCookiesPolicyLegalCookieStatementGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCookiesPolicyLegalCookieStatementGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>
>;
export type GetCookiesPolicyLegalCookieStatementGetQueryError = unknown;

export function useGetCookiesPolicyLegalCookieStatementGet<
  TData = Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCookiesPolicyLegalCookieStatementGet<
  TData = Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCookiesPolicyLegalCookieStatementGet<
  TData = Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Cookies Policy
 */

export function useGetCookiesPolicyLegalCookieStatementGet<
  TData = Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCookiesPolicyLegalCookieStatementGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCookiesPolicyLegalCookieStatementGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Terms And Conditions
 */
export const getTermsAndConditionsLegalTermsOfUseGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<LegalPolicyViewModel>(
    { url: `/legal/terms-of-use`, method: "GET" },
    options,
  );
};

export const getGetTermsAndConditionsLegalTermsOfUseGetQueryKey = () => {
  return [`/legal/terms-of-use`] as const;
};

export const getGetTermsAndConditionsLegalTermsOfUseGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTermsAndConditionsLegalTermsOfUseGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>
  > = () => getTermsAndConditionsLegalTermsOfUseGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTermsAndConditionsLegalTermsOfUseGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>
>;
export type GetTermsAndConditionsLegalTermsOfUseGetQueryError = unknown;

export function useGetTermsAndConditionsLegalTermsOfUseGet<
  TData = Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTermsAndConditionsLegalTermsOfUseGet<
  TData = Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTermsAndConditionsLegalTermsOfUseGet<
  TData = Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Terms And Conditions
 */

export function useGetTermsAndConditionsLegalTermsOfUseGet<
  TData = Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTermsAndConditionsLegalTermsOfUseGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTermsAndConditionsLegalTermsOfUseGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get User Acceptance Status
 */
export const getUserAcceptanceStatusLegalTermsOfUseStatusGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<TermsAndConditionsStatusViewModel>(
    { url: `/legal/terms-of-use/status`, method: "GET" },
    options,
  );
};

export const getGetUserAcceptanceStatusLegalTermsOfUseStatusGetQueryKey =
  () => {
    return [`/legal/terms-of-use/status`] as const;
  };

export const getGetUserAcceptanceStatusLegalTermsOfUseStatusGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserAcceptanceStatusLegalTermsOfUseStatusGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>>
  > = () => getUserAcceptanceStatusLegalTermsOfUseStatusGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserAcceptanceStatusLegalTermsOfUseStatusGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>>
  >;
export type GetUserAcceptanceStatusLegalTermsOfUseStatusGetQueryError = unknown;

export function useGetUserAcceptanceStatusLegalTermsOfUseStatusGet<
  TData = Awaited<
    ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
  >,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
      >,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<
          ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
        >,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserAcceptanceStatusLegalTermsOfUseStatusGet<
  TData = Awaited<
    ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
      >,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<
          ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
        >,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserAcceptanceStatusLegalTermsOfUseStatusGet<
  TData = Awaited<
    ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Acceptance Status
 */

export function useGetUserAcceptanceStatusLegalTermsOfUseStatusGet<
  TData = Awaited<
    ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserAcceptanceStatusLegalTermsOfUseStatusGet>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetUserAcceptanceStatusLegalTermsOfUseStatusGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update User Terms And Conditions Status Async
 */
export const updateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPut = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    { url: `/legal/terms-of-use/status`, method: "PUT" },
    options,
  );
};

export const getUpdateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPutMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPut
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPut
      >
    >,
    TError,
    void,
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPut
        >
      >,
      void
    > = () => {
      return updateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPut(
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPut
      >
    >
  >;

export type UpdateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPutMutationError =
  unknown;

/**
 * @summary Update User Terms And Conditions Status Async
 */
export const useUpdateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPut =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPut
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPut
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationOptions =
      getUpdateUserTermsAndConditionsStatusAsyncLegalTermsOfUseStatusPutMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Alert Details For Admin Panel
 */
export const getAlertDetailsForAdminPanelAlertsGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<GetAlertDetailsForAdminPanelAlertsGet200>(
    { url: `/alerts`, method: "GET" },
    options,
  );
};

export const getGetAlertDetailsForAdminPanelAlertsGetQueryKey = () => {
  return [`/alerts`] as const;
};

export const getGetAlertDetailsForAdminPanelAlertsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAlertDetailsForAdminPanelAlertsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>
  > = () => getAlertDetailsForAdminPanelAlertsGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAlertDetailsForAdminPanelAlertsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>
>;
export type GetAlertDetailsForAdminPanelAlertsGetQueryError = unknown;

export function useGetAlertDetailsForAdminPanelAlertsGet<
  TData = Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAlertDetailsForAdminPanelAlertsGet<
  TData = Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAlertDetailsForAdminPanelAlertsGet<
  TData = Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Alert Details For Admin Panel
 */

export function useGetAlertDetailsForAdminPanelAlertsGet<
  TData = Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAlertDetailsForAdminPanelAlertsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAlertDetailsForAdminPanelAlertsGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Alert
 */
export const createAlertAlertsPost = (
  alertRequest: AlertRequest,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<AlertDetailsViewModel>(
    {
      url: `/alerts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: alertRequest,
    },
    options,
  );
};

export const getCreateAlertAlertsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAlertAlertsPost>>,
    TError,
    { data: AlertRequest },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAlertAlertsPost>>,
  TError,
  { data: AlertRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAlertAlertsPost>>,
    { data: AlertRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createAlertAlertsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAlertAlertsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAlertAlertsPost>>
>;
export type CreateAlertAlertsPostMutationBody = AlertRequest;
export type CreateAlertAlertsPostMutationError = HTTPValidationError;

/**
 * @summary Create Alert
 */
export const useCreateAlertAlertsPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAlertAlertsPost>>,
    TError,
    { data: AlertRequest },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAlertAlertsPost>>,
  TError,
  { data: AlertRequest },
  TContext
> => {
  const mutationOptions = getCreateAlertAlertsPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update Alert Status
 */
export const updateAlertStatusAlertsAlertIdPut = (
  alertId: string,
  alertStatusUpdate: AlertStatusUpdate,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    {
      url: `/alerts/${alertId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: alertStatusUpdate,
    },
    options,
  );
};

export const getUpdateAlertStatusAlertsAlertIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAlertStatusAlertsAlertIdPut>>,
    TError,
    { alertId: string; data: AlertStatusUpdate },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAlertStatusAlertsAlertIdPut>>,
  TError,
  { alertId: string; data: AlertStatusUpdate },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAlertStatusAlertsAlertIdPut>>,
    { alertId: string; data: AlertStatusUpdate }
  > = (props) => {
    const { alertId, data } = props ?? {};

    return updateAlertStatusAlertsAlertIdPut(alertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAlertStatusAlertsAlertIdPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAlertStatusAlertsAlertIdPut>>
>;
export type UpdateAlertStatusAlertsAlertIdPutMutationBody = AlertStatusUpdate;
export type UpdateAlertStatusAlertsAlertIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Alert Status
 */
export const useUpdateAlertStatusAlertsAlertIdPut = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAlertStatusAlertsAlertIdPut>>,
    TError,
    { alertId: string; data: AlertStatusUpdate },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAlertStatusAlertsAlertIdPut>>,
  TError,
  { alertId: string; data: AlertStatusUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateAlertStatusAlertsAlertIdPutMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Reset Alert
 */
export const resetAlertAlertsAlertIdResetPost = (
  alertId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<AlertDetailsViewModel>(
    { url: `/alerts/${alertId}/reset`, method: "POST" },
    options,
  );
};

export const getResetAlertAlertsAlertIdResetPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetAlertAlertsAlertIdResetPost>>,
    TError,
    { alertId: number },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetAlertAlertsAlertIdResetPost>>,
  TError,
  { alertId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetAlertAlertsAlertIdResetPost>>,
    { alertId: number }
  > = (props) => {
    const { alertId } = props ?? {};

    return resetAlertAlertsAlertIdResetPost(alertId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetAlertAlertsAlertIdResetPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetAlertAlertsAlertIdResetPost>>
>;

export type ResetAlertAlertsAlertIdResetPostMutationError = HTTPValidationError;

/**
 * @summary Reset Alert
 */
export const useResetAlertAlertsAlertIdResetPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetAlertAlertsAlertIdResetPost>>,
    TError,
    { alertId: number },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetAlertAlertsAlertIdResetPost>>,
  TError,
  { alertId: number },
  TContext
> => {
  const mutationOptions =
    getResetAlertAlertsAlertIdResetPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get All Members
 */
export const getAllMembersMembersGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<MemberDetails[]>(
    { url: `/members`, method: "GET" },
    options,
  );
};

export const getGetAllMembersMembersGetQueryKey = () => {
  return [`/members`] as const;
};

export const getGetAllMembersMembersGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllMembersMembersGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMembersMembersGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllMembersMembersGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllMembersMembersGet>>
  > = () => getAllMembersMembersGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllMembersMembersGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllMembersMembersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllMembersMembersGet>>
>;
export type GetAllMembersMembersGetQueryError = unknown;

export function useGetAllMembersMembersGet<
  TData = Awaited<ReturnType<typeof getAllMembersMembersGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMembersMembersGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAllMembersMembersGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllMembersMembersGet<
  TData = Awaited<ReturnType<typeof getAllMembersMembersGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMembersMembersGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAllMembersMembersGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllMembersMembersGet<
  TData = Awaited<ReturnType<typeof getAllMembersMembersGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMembersMembersGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get All Members
 */

export function useGetAllMembersMembersGet<
  TData = Awaited<ReturnType<typeof getAllMembersMembersGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMembersMembersGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllMembersMembersGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Member
 */
export const createMemberMembersPost = (
  createMemberModel: CreateMemberModel,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<MemberDetails>(
    {
      url: `/members`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createMemberModel,
    },
    options,
  );
};

export const getCreateMemberMembersPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMemberMembersPost>>,
    TError,
    { data: CreateMemberModel },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMemberMembersPost>>,
  TError,
  { data: CreateMemberModel },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMemberMembersPost>>,
    { data: CreateMemberModel }
  > = (props) => {
    const { data } = props ?? {};

    return createMemberMembersPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMemberMembersPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMemberMembersPost>>
>;
export type CreateMemberMembersPostMutationBody = CreateMemberModel;
export type CreateMemberMembersPostMutationError = HTTPValidationError;

/**
 * @summary Create Member
 */
export const useCreateMemberMembersPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMemberMembersPost>>,
    TError,
    { data: CreateMemberModel },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMemberMembersPost>>,
  TError,
  { data: CreateMemberModel },
  TContext
> => {
  const mutationOptions = getCreateMemberMembersPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Edit Member By Id
 */
export const editMemberByIdMembersMemberIdPatch = (
  memberId: number,
  editMemberModel: EditMemberModel,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<MemberDetails>(
    {
      url: `/members/${memberId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: editMemberModel,
    },
    options,
  );
};

export const getEditMemberByIdMembersMemberIdPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editMemberByIdMembersMemberIdPatch>>,
    TError,
    { memberId: number; data: EditMemberModel },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editMemberByIdMembersMemberIdPatch>>,
  TError,
  { memberId: number; data: EditMemberModel },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editMemberByIdMembersMemberIdPatch>>,
    { memberId: number; data: EditMemberModel }
  > = (props) => {
    const { memberId, data } = props ?? {};

    return editMemberByIdMembersMemberIdPatch(memberId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditMemberByIdMembersMemberIdPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof editMemberByIdMembersMemberIdPatch>>
>;
export type EditMemberByIdMembersMemberIdPatchMutationBody = EditMemberModel;
export type EditMemberByIdMembersMemberIdPatchMutationError =
  HTTPValidationError;

/**
 * @summary Edit Member By Id
 */
export const useEditMemberByIdMembersMemberIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editMemberByIdMembersMemberIdPatch>>,
    TError,
    { memberId: number; data: EditMemberModel },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof editMemberByIdMembersMemberIdPatch>>,
  TError,
  { memberId: number; data: EditMemberModel },
  TContext
> => {
  const mutationOptions =
    getEditMemberByIdMembersMemberIdPatchMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Deactivate Member By Id
 */
export const deactivateMemberByIdMembersMemberIdDeactivatePost = (
  memberId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    { url: `/members/${memberId}/deactivate`, method: "POST" },
    options,
  );
};

export const getDeactivateMemberByIdMembersMemberIdDeactivatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deactivateMemberByIdMembersMemberIdDeactivatePost>
      >,
      TError,
      { memberId: number },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deactivateMemberByIdMembersMemberIdDeactivatePost>
    >,
    TError,
    { memberId: number },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deactivateMemberByIdMembersMemberIdDeactivatePost>
      >,
      { memberId: number }
    > = (props) => {
      const { memberId } = props ?? {};

      return deactivateMemberByIdMembersMemberIdDeactivatePost(
        memberId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeactivateMemberByIdMembersMemberIdDeactivatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deactivateMemberByIdMembersMemberIdDeactivatePost>
    >
  >;

export type DeactivateMemberByIdMembersMemberIdDeactivatePostMutationError =
  HTTPValidationError;

/**
 * @summary Deactivate Member By Id
 */
export const useDeactivateMemberByIdMembersMemberIdDeactivatePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof deactivateMemberByIdMembersMemberIdDeactivatePost>
    >,
    TError,
    { memberId: number },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deactivateMemberByIdMembersMemberIdDeactivatePost>>,
  TError,
  { memberId: number },
  TContext
> => {
  const mutationOptions =
    getDeactivateMemberByIdMembersMemberIdDeactivatePostMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

/**
 * @summary Activate Member By Id
 */
export const activateMemberByIdMembersMemberIdActivatePost = (
  memberId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    { url: `/members/${memberId}/activate`, method: "POST" },
    options,
  );
};

export const getActivateMemberByIdMembersMemberIdActivatePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateMemberByIdMembersMemberIdActivatePost>>,
    TError,
    { memberId: number },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateMemberByIdMembersMemberIdActivatePost>>,
  TError,
  { memberId: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateMemberByIdMembersMemberIdActivatePost>>,
    { memberId: number }
  > = (props) => {
    const { memberId } = props ?? {};

    return activateMemberByIdMembersMemberIdActivatePost(
      memberId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateMemberByIdMembersMemberIdActivatePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof activateMemberByIdMembersMemberIdActivatePost>>
  >;

export type ActivateMemberByIdMembersMemberIdActivatePostMutationError =
  HTTPValidationError;

/**
 * @summary Activate Member By Id
 */
export const useActivateMemberByIdMembersMemberIdActivatePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateMemberByIdMembersMemberIdActivatePost>>,
    TError,
    { memberId: number },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof activateMemberByIdMembersMemberIdActivatePost>>,
  TError,
  { memberId: number },
  TContext
> => {
  const mutationOptions =
    getActivateMemberByIdMembersMemberIdActivatePostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Lock All Members
 */
export const lockAllMembersMembersLockAllPost = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    { url: `/members/lock_all`, method: "POST" },
    options,
  );
};

export const getLockAllMembersMembersLockAllPostMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockAllMembersMembersLockAllPost>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lockAllMembersMembersLockAllPost>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lockAllMembersMembersLockAllPost>>,
    void
  > = () => {
    return lockAllMembersMembersLockAllPost(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LockAllMembersMembersLockAllPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof lockAllMembersMembersLockAllPost>>
>;

export type LockAllMembersMembersLockAllPostMutationError = unknown;

/**
 * @summary Lock All Members
 */
export const useLockAllMembersMembersLockAllPost = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockAllMembersMembersLockAllPost>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lockAllMembersMembersLockAllPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getLockAllMembersMembersLockAllPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Unlock All Members
 */
export const unlockAllMembersMembersUnlockAllPost = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    { url: `/members/unlock_all`, method: "POST" },
    options,
  );
};

export const getUnlockAllMembersMembersUnlockAllPostMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockAllMembersMembersUnlockAllPost>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlockAllMembersMembersUnlockAllPost>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlockAllMembersMembersUnlockAllPost>>,
    void
  > = () => {
    return unlockAllMembersMembersUnlockAllPost(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlockAllMembersMembersUnlockAllPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlockAllMembersMembersUnlockAllPost>>
>;

export type UnlockAllMembersMembersUnlockAllPostMutationError = unknown;

/**
 * @summary Unlock All Members
 */
export const useUnlockAllMembersMembersUnlockAllPost = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockAllMembersMembersUnlockAllPost>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlockAllMembersMembersUnlockAllPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getUnlockAllMembersMembersUnlockAllPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Member Countries
 */
export const getMemberCountriesMembersCountriesGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<CountryViewModel[]>(
    { url: `/members/countries`, method: "GET" },
    options,
  );
};

export const getGetMemberCountriesMembersCountriesGetQueryKey = () => {
  return [`/members/countries`] as const;
};

export const getGetMemberCountriesMembersCountriesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMemberCountriesMembersCountriesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>
  > = () => getMemberCountriesMembersCountriesGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMemberCountriesMembersCountriesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>
>;
export type GetMemberCountriesMembersCountriesGetQueryError = unknown;

export function useGetMemberCountriesMembersCountriesGet<
  TData = Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMemberCountriesMembersCountriesGet<
  TData = Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMemberCountriesMembersCountriesGet<
  TData = Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Member Countries
 */

export function useGetMemberCountriesMembersCountriesGet<
  TData = Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMemberCountriesMembersCountriesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMemberCountriesMembersCountriesGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Member Info
 */
export const getMemberInfoMembersMemberInfoGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<MemberDetails>(
    { url: `/members/member-info`, method: "GET" },
    options,
  );
};

export const getGetMemberInfoMembersMemberInfoGetQueryKey = () => {
  return [`/members/member-info`] as const;
};

export const getGetMemberInfoMembersMemberInfoGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMemberInfoMembersMemberInfoGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>
  > = () => getMemberInfoMembersMemberInfoGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMemberInfoMembersMemberInfoGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>
>;
export type GetMemberInfoMembersMemberInfoGetQueryError = unknown;

export function useGetMemberInfoMembersMemberInfoGet<
  TData = Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMemberInfoMembersMemberInfoGet<
  TData = Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMemberInfoMembersMemberInfoGet<
  TData = Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Member Info
 */

export function useGetMemberInfoMembersMemberInfoGet<
  TData = Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMemberInfoMembersMemberInfoGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMemberInfoMembersMemberInfoGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download All Active Members
 */
export const downloadAllActiveMembersMembersDownloadGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<unknown>(
    { url: `/members/download`, method: "GET" },
    options,
  );
};

export const getDownloadAllActiveMembersMembersDownloadGetQueryKey = () => {
  return [`/members/download`] as const;
};

export const getDownloadAllActiveMembersMembersDownloadGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadAllActiveMembersMembersDownloadGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>>
  > = () => downloadAllActiveMembersMembersDownloadGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DownloadAllActiveMembersMembersDownloadGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>>
>;
export type DownloadAllActiveMembersMembersDownloadGetQueryError = unknown;

export function useDownloadAllActiveMembersMembersDownloadGet<
  TData = Awaited<
    ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>
  >,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadAllActiveMembersMembersDownloadGet<
  TData = Awaited<
    ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadAllActiveMembersMembersDownloadGet<
  TData = Awaited<
    ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download All Active Members
 */

export function useDownloadAllActiveMembersMembersDownloadGet<
  TData = Awaited<
    ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof downloadAllActiveMembersMembersDownloadGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadAllActiveMembersMembersDownloadGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Upload Bulk User
 */
export const uploadBulkUserMembersUploadPost = (
  bodyUploadBulkUserMembersUploadPost: BodyUploadBulkUserMembersUploadPost,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  const formData = new FormData();
  formData.append("file", bodyUploadBulkUserMembersUploadPost.file);

  return withCustomAxios<unknown>(
    {
      url: `/members/upload`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getUploadBulkUserMembersUploadPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadBulkUserMembersUploadPost>>,
    TError,
    { data: BodyUploadBulkUserMembersUploadPost },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadBulkUserMembersUploadPost>>,
  TError,
  { data: BodyUploadBulkUserMembersUploadPost },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadBulkUserMembersUploadPost>>,
    { data: BodyUploadBulkUserMembersUploadPost }
  > = (props) => {
    const { data } = props ?? {};

    return uploadBulkUserMembersUploadPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadBulkUserMembersUploadPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadBulkUserMembersUploadPost>>
>;
export type UploadBulkUserMembersUploadPostMutationBody =
  BodyUploadBulkUserMembersUploadPost;
export type UploadBulkUserMembersUploadPostMutationError = HTTPValidationError;

/**
 * @summary Upload Bulk User
 */
export const useUploadBulkUserMembersUploadPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadBulkUserMembersUploadPost>>,
    TError,
    { data: BodyUploadBulkUserMembersUploadPost },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadBulkUserMembersUploadPost>>,
  TError,
  { data: BodyUploadBulkUserMembersUploadPost },
  TContext
> => {
  const mutationOptions =
    getUploadBulkUserMembersUploadPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Edit Bulk Permissions
 */
export const editBulkPermissionsMembersPermissionsPatch = (
  bulkMemberPermissionsModel: BulkMemberPermissionsModel,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<unknown>(
    {
      url: `/members/permissions`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: bulkMemberPermissionsModel,
    },
    options,
  );
};

export const getEditBulkPermissionsMembersPermissionsPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editBulkPermissionsMembersPermissionsPatch>>,
    TError,
    { data: BulkMemberPermissionsModel },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editBulkPermissionsMembersPermissionsPatch>>,
  TError,
  { data: BulkMemberPermissionsModel },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editBulkPermissionsMembersPermissionsPatch>>,
    { data: BulkMemberPermissionsModel }
  > = (props) => {
    const { data } = props ?? {};

    return editBulkPermissionsMembersPermissionsPatch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditBulkPermissionsMembersPermissionsPatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof editBulkPermissionsMembersPermissionsPatch>>
  >;
export type EditBulkPermissionsMembersPermissionsPatchMutationBody =
  BulkMemberPermissionsModel;
export type EditBulkPermissionsMembersPermissionsPatchMutationError =
  HTTPValidationError;

/**
 * @summary Edit Bulk Permissions
 */
export const useEditBulkPermissionsMembersPermissionsPatch = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editBulkPermissionsMembersPermissionsPatch>>,
    TError,
    { data: BulkMemberPermissionsModel },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof editBulkPermissionsMembersPermissionsPatch>>,
  TError,
  { data: BulkMemberPermissionsModel },
  TContext
> => {
  const mutationOptions =
    getEditBulkPermissionsMembersPermissionsPatchMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Version History
 */
export const getVersionHistoryIngestGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<IngestViewModel[]>(
    { url: `/ingest`, method: "GET" },
    options,
  );
};

export const getGetVersionHistoryIngestGetQueryKey = () => {
  return [`/ingest`] as const;
};

export const getGetVersionHistoryIngestGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVersionHistoryIngestGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVersionHistoryIngestGet>>
  > = () => getVersionHistoryIngestGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVersionHistoryIngestGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVersionHistoryIngestGet>>
>;
export type GetVersionHistoryIngestGetQueryError = unknown;

export function useGetVersionHistoryIngestGet<
  TData = Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVersionHistoryIngestGet<
  TData = Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVersionHistoryIngestGet<
  TData = Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Version History
 */

export function useGetVersionHistoryIngestGet<
  TData = Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getVersionHistoryIngestGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVersionHistoryIngestGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download File Blob Storage
 */
export const downloadFileBlobStorageIngestDownloadDatasetIdGet = (
  datasetId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<unknown>(
    { url: `/ingest/download/${datasetId}`, method: "GET" },
    options,
  );
};

export const getDownloadFileBlobStorageIngestDownloadDatasetIdGetQueryKey = (
  datasetId: number,
) => {
  return [`/ingest/download/${datasetId}`] as const;
};

export const getDownloadFileBlobStorageIngestDownloadDatasetIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
    >,
    TError = HTTPValidationError,
  >(
    datasetId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof withCustomAxios>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDownloadFileBlobStorageIngestDownloadDatasetIdGetQueryKey(datasetId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
      >
    > = () =>
      downloadFileBlobStorageIngestDownloadDatasetIdGet(
        datasetId,
        requestOptions,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!datasetId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DownloadFileBlobStorageIngestDownloadDatasetIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
    >
  >;
export type DownloadFileBlobStorageIngestDownloadDatasetIdGetQueryError =
  HTTPValidationError;

export function useDownloadFileBlobStorageIngestDownloadDatasetIdGet<
  TData = Awaited<
    ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
  >,
  TError = HTTPValidationError,
>(
  datasetId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadFileBlobStorageIngestDownloadDatasetIdGet<
  TData = Awaited<
    ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
  >,
  TError = HTTPValidationError,
>(
  datasetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadFileBlobStorageIngestDownloadDatasetIdGet<
  TData = Awaited<
    ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
  >,
  TError = HTTPValidationError,
>(
  datasetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download File Blob Storage
 */

export function useDownloadFileBlobStorageIngestDownloadDatasetIdGet<
  TData = Awaited<
    ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
  >,
  TError = HTTPValidationError,
>(
  datasetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof downloadFileBlobStorageIngestDownloadDatasetIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadFileBlobStorageIngestDownloadDatasetIdGetQueryOptions(
      datasetId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Categories
 */
export const getCategoriesCategoriesGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<CategoryViewModel[]>(
    { url: `/categories`, method: "GET" },
    options,
  );
};

export const getGetCategoriesCategoriesGetQueryKey = () => {
  return [`/categories`] as const;
};

export const getGetCategoriesCategoriesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCategoriesCategoriesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCategoriesCategoriesGet>>
  > = () => getCategoriesCategoriesGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCategoriesCategoriesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCategoriesCategoriesGet>>
>;
export type GetCategoriesCategoriesGetQueryError = unknown;

export function useGetCategoriesCategoriesGet<
  TData = Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCategoriesCategoriesGet<
  TData = Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCategoriesCategoriesGet<
  TData = Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Categories
 */

export function useGetCategoriesCategoriesGet<
  TData = Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCategoriesCategoriesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCategoriesCategoriesGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Pack Types
 */
export const getPackTypesPackTypesGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<PackTypeViewModel[]>(
    { url: `/pack-types`, method: "GET" },
    options,
  );
};

export const getGetPackTypesPackTypesGetQueryKey = () => {
  return [`/pack-types`] as const;
};

export const getGetPackTypesPackTypesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPackTypesPackTypesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPackTypesPackTypesGet>>
  > = () => getPackTypesPackTypesGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPackTypesPackTypesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPackTypesPackTypesGet>>
>;
export type GetPackTypesPackTypesGetQueryError = unknown;

export function useGetPackTypesPackTypesGet<
  TData = Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPackTypesPackTypesGet<
  TData = Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPackTypesPackTypesGet<
  TData = Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pack Types
 */

export function useGetPackTypesPackTypesGet<
  TData = Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPackTypesPackTypesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPackTypesPackTypesGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Data Management Numeric Data
 */
export const getDataManagementNumericDataDataManagementExportAvailableDataNumericGet =
  (options?: SecondParameter<typeof withCustomAxios>) => {
    return withCustomAxios<GetDataManagementNumericDataDataManagementExportAvailableDataNumericGet200>(
      { url: `/data-management/export/available-data/numeric`, method: "GET" },
      options,
    );
  };

export const getGetDataManagementNumericDataDataManagementExportAvailableDataNumericGetQueryKey =
  () => {
    return [`/data-management/export/available-data/numeric`] as const;
  };

export const getGetDataManagementNumericDataDataManagementExportAvailableDataNumericGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
      >
    >,
    TError = unknown,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDataManagementNumericDataDataManagementExportAvailableDataNumericGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
        >
      >
    > = () =>
      getDataManagementNumericDataDataManagementExportAvailableDataNumericGet(
        requestOptions,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDataManagementNumericDataDataManagementExportAvailableDataNumericGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
      >
    >
  >;
export type GetDataManagementNumericDataDataManagementExportAvailableDataNumericGetQueryError =
  unknown;

export function useGetDataManagementNumericDataDataManagementExportAvailableDataNumericGet<
  TData = Awaited<
    ReturnType<
      typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
    >
  >,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
        >
      >,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<
          ReturnType<
            typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
          >
        >,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDataManagementNumericDataDataManagementExportAvailableDataNumericGet<
  TData = Awaited<
    ReturnType<
      typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
    >
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
        >
      >,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<
          ReturnType<
            typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
          >
        >,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDataManagementNumericDataDataManagementExportAvailableDataNumericGet<
  TData = Awaited<
    ReturnType<
      typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
    >
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
        >
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Data Management Numeric Data
 */

export function useGetDataManagementNumericDataDataManagementExportAvailableDataNumericGet<
  TData = Awaited<
    ReturnType<
      typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
    >
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDataManagementNumericDataDataManagementExportAvailableDataNumericGet
        >
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDataManagementNumericDataDataManagementExportAvailableDataNumericGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Data Management Configuration Data
 */
export const getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet =
  (options?: SecondParameter<typeof withCustomAxios>) => {
    return withCustomAxios<GetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet200>(
      {
        url: `/data-management/export/available-data/configuration`,
        method: "GET",
      },
      options,
    );
  };

export const getGetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGetQueryKey =
  () => {
    return [`/data-management/export/available-data/configuration`] as const;
  };

export const getGetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
      >
    >,
    TError = unknown,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
        >
      >
    > = () =>
      getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet(
        requestOptions,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
      >
    >
  >;
export type GetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGetQueryError =
  unknown;

export function useGetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet<
  TData = Awaited<
    ReturnType<
      typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
    >
  >,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
        >
      >,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<
          ReturnType<
            typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
          >
        >,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet<
  TData = Awaited<
    ReturnType<
      typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
    >
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
        >
      >,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<
          ReturnType<
            typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
          >
        >,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet<
  TData = Awaited<
    ReturnType<
      typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
    >
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
        >
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Data Management Configuration Data
 */

export function useGetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet<
  TData = Awaited<
    ReturnType<
      typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
    >
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGet
        >
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDataManagementConfigurationDataDataManagementExportAvailableDataConfigurationGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Export Data Extract
 */
export const exportDataExtractDataManagementExportPost = (
  dataExtractRequest: DataExtractRequest,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    {
      url: `/data-management/export`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dataExtractRequest,
    },
    options,
  );
};

export const getExportDataExtractDataManagementExportPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportDataExtractDataManagementExportPost>>,
    TError,
    { data: DataExtractRequest },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportDataExtractDataManagementExportPost>>,
  TError,
  { data: DataExtractRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportDataExtractDataManagementExportPost>>,
    { data: DataExtractRequest }
  > = (props) => {
    const { data } = props ?? {};

    return exportDataExtractDataManagementExportPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportDataExtractDataManagementExportPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof exportDataExtractDataManagementExportPost>>
  >;
export type ExportDataExtractDataManagementExportPostMutationBody =
  DataExtractRequest;
export type ExportDataExtractDataManagementExportPostMutationError =
  HTTPValidationError;

/**
 * @summary Export Data Extract
 */
export const useExportDataExtractDataManagementExportPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportDataExtractDataManagementExportPost>>,
    TError,
    { data: DataExtractRequest },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof exportDataExtractDataManagementExportPost>>,
  TError,
  { data: DataExtractRequest },
  TContext
> => {
  const mutationOptions =
    getExportDataExtractDataManagementExportPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get All Functional Areas
 */
export const getAllFunctionalAreasUserManagementFunctionalAreasGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<FunctionalAreaItemViewModel[]>(
    { url: `/user-management/functional-areas`, method: "GET" },
    options,
  );
};

export const getGetAllFunctionalAreasUserManagementFunctionalAreasGetQueryKey =
  () => {
    return [`/user-management/functional-areas`] as const;
  };

export const getGetAllFunctionalAreasUserManagementFunctionalAreasGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
    >,
    TError = unknown,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAllFunctionalAreasUserManagementFunctionalAreasGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAllFunctionalAreasUserManagementFunctionalAreasGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
      >
    > = () =>
      getAllFunctionalAreasUserManagementFunctionalAreasGet(requestOptions);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAllFunctionalAreasUserManagementFunctionalAreasGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
    >
  >;
export type GetAllFunctionalAreasUserManagementFunctionalAreasGetQueryError =
  unknown;

export function useGetAllFunctionalAreasUserManagementFunctionalAreasGet<
  TData = Awaited<
    ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
  >,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
      >,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<
          ReturnType<
            typeof getAllFunctionalAreasUserManagementFunctionalAreasGet
          >
        >,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllFunctionalAreasUserManagementFunctionalAreasGet<
  TData = Awaited<
    ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
      >,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<
          ReturnType<
            typeof getAllFunctionalAreasUserManagementFunctionalAreasGet
          >
        >,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllFunctionalAreasUserManagementFunctionalAreasGet<
  TData = Awaited<
    ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get All Functional Areas
 */

export function useGetAllFunctionalAreasUserManagementFunctionalAreasGet<
  TData = Awaited<
    ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getAllFunctionalAreasUserManagementFunctionalAreasGet>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAllFunctionalAreasUserManagementFunctionalAreasGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Test Data
 */
export const getTestDataTestGenerateTestDataGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<unknown>(
    { url: `/test/generate-test-data`, method: "GET" },
    options,
  );
};

export const getGetTestDataTestGenerateTestDataGetQueryKey = () => {
  return [`/test/generate-test-data`] as const;
};

export const getGetTestDataTestGenerateTestDataGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTestDataTestGenerateTestDataGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>
  > = () => getTestDataTestGenerateTestDataGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTestDataTestGenerateTestDataGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>
>;
export type GetTestDataTestGenerateTestDataGetQueryError = unknown;

export function useGetTestDataTestGenerateTestDataGet<
  TData = Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTestDataTestGenerateTestDataGet<
  TData = Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTestDataTestGenerateTestDataGet<
  TData = Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Test Data
 */

export function useGetTestDataTestGenerateTestDataGet<
  TData = Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTestDataTestGenerateTestDataGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTestDataTestGenerateTestDataGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Product
 */
export const updateProductScenariosMicroScenarioIdProductsProductGuidPatch = (
  scenarioId: number,
  productGuid: string,
  editMicroScenarioProductDto: EditMicroScenarioProductDto,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    {
      url: `/scenarios/micro/${scenarioId}/products/${productGuid}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: editMicroScenarioProductDto,
    },
    options,
  );
};

export const getUpdateProductScenariosMicroScenarioIdProductsProductGuidPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateProductScenariosMicroScenarioIdProductsProductGuidPatch
        >
      >,
      TError,
      {
        scenarioId: number;
        productGuid: string;
        data: EditMicroScenarioProductDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateProductScenariosMicroScenarioIdProductsProductGuidPatch
      >
    >,
    TError,
    {
      scenarioId: number;
      productGuid: string;
      data: EditMicroScenarioProductDto;
    },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateProductScenariosMicroScenarioIdProductsProductGuidPatch
        >
      >,
      {
        scenarioId: number;
        productGuid: string;
        data: EditMicroScenarioProductDto;
      }
    > = (props) => {
      const { scenarioId, productGuid, data } = props ?? {};

      return updateProductScenariosMicroScenarioIdProductsProductGuidPatch(
        scenarioId,
        productGuid,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateProductScenariosMicroScenarioIdProductsProductGuidPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateProductScenariosMicroScenarioIdProductsProductGuidPatch
      >
    >
  >;
export type UpdateProductScenariosMicroScenarioIdProductsProductGuidPatchMutationBody =
  EditMicroScenarioProductDto;
export type UpdateProductScenariosMicroScenarioIdProductsProductGuidPatchMutationError =
  HTTPValidationError;

/**
 * @summary Update Product
 */
export const useUpdateProductScenariosMicroScenarioIdProductsProductGuidPatch =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateProductScenariosMicroScenarioIdProductsProductGuidPatch
        >
      >,
      TError,
      {
        scenarioId: number;
        productGuid: string;
        data: EditMicroScenarioProductDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateProductScenariosMicroScenarioIdProductsProductGuidPatch
      >
    >,
    TError,
    {
      scenarioId: number;
      productGuid: string;
      data: EditMicroScenarioProductDto;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateProductScenariosMicroScenarioIdProductsProductGuidPatchMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Delete Product
 */
export const deleteProductScenariosMicroScenarioIdProductsProductGuidDelete = (
  scenarioId: number,
  productGuid: string,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    {
      url: `/scenarios/micro/${scenarioId}/products/${productGuid}`,
      method: "DELETE",
    },
    options,
  );
};

export const getDeleteProductScenariosMicroScenarioIdProductsProductGuidDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteProductScenariosMicroScenarioIdProductsProductGuidDelete
        >
      >,
      TError,
      { scenarioId: number; productGuid: string },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteProductScenariosMicroScenarioIdProductsProductGuidDelete
      >
    >,
    TError,
    { scenarioId: number; productGuid: string },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteProductScenariosMicroScenarioIdProductsProductGuidDelete
        >
      >,
      { scenarioId: number; productGuid: string }
    > = (props) => {
      const { scenarioId, productGuid } = props ?? {};

      return deleteProductScenariosMicroScenarioIdProductsProductGuidDelete(
        scenarioId,
        productGuid,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteProductScenariosMicroScenarioIdProductsProductGuidDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteProductScenariosMicroScenarioIdProductsProductGuidDelete
      >
    >
  >;

export type DeleteProductScenariosMicroScenarioIdProductsProductGuidDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Product
 */
export const useDeleteProductScenariosMicroScenarioIdProductsProductGuidDelete =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteProductScenariosMicroScenarioIdProductsProductGuidDelete
        >
      >,
      TError,
      { scenarioId: number; productGuid: string },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteProductScenariosMicroScenarioIdProductsProductGuidDelete
      >
    >,
    TError,
    { scenarioId: number; productGuid: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteProductScenariosMicroScenarioIdProductsProductGuidDeleteMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Duplicate Product
 */
export const duplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePost =
  (
    scenarioId: number,
    productGuid: string,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<Product>(
      {
        url: `/scenarios/micro/${scenarioId}/products/${productGuid}/duplicate`,
        method: "POST",
      },
      options,
    );
  };

export const getDuplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof duplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePost
        >
      >,
      TError,
      { scenarioId: number; productGuid: string },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof duplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePost
      >
    >,
    TError,
    { scenarioId: number; productGuid: string },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof duplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePost
        >
      >,
      { scenarioId: number; productGuid: string }
    > = (props) => {
      const { scenarioId, productGuid } = props ?? {};

      return duplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePost(
        scenarioId,
        productGuid,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DuplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof duplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePost
      >
    >
  >;

export type DuplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePostMutationError =
  HTTPValidationError;

/**
 * @summary Duplicate Product
 */
export const useDuplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof duplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePost
        >
      >,
      TError,
      { scenarioId: number; productGuid: string },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof duplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePost
      >
    >,
    TError,
    { scenarioId: number; productGuid: string },
    TContext
  > => {
    const mutationOptions =
      getDuplicateProductScenariosMicroScenarioIdProductsProductGuidDuplicatePostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Add Products To Micro Scenario
 */
export const addProductsToMicroScenarioScenariosMicroScenarioIdProductsPost = (
  scenarioId: number,
  addProductsToMicroScenarioScenariosMicroScenarioIdProductsPostBody: number[],
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<Product[]>(
    {
      url: `/scenarios/micro/${scenarioId}/products`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addProductsToMicroScenarioScenariosMicroScenarioIdProductsPostBody,
    },
    options,
  );
};

export const getAddProductsToMicroScenarioScenariosMicroScenarioIdProductsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addProductsToMicroScenarioScenariosMicroScenarioIdProductsPost
        >
      >,
      TError,
      { scenarioId: number; data: number[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addProductsToMicroScenarioScenariosMicroScenarioIdProductsPost
      >
    >,
    TError,
    { scenarioId: number; data: number[] },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addProductsToMicroScenarioScenariosMicroScenarioIdProductsPost
        >
      >,
      { scenarioId: number; data: number[] }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return addProductsToMicroScenarioScenariosMicroScenarioIdProductsPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddProductsToMicroScenarioScenariosMicroScenarioIdProductsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addProductsToMicroScenarioScenariosMicroScenarioIdProductsPost
      >
    >
  >;
export type AddProductsToMicroScenarioScenariosMicroScenarioIdProductsPostMutationBody =
  number[];
export type AddProductsToMicroScenarioScenariosMicroScenarioIdProductsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Products To Micro Scenario
 */
export const useAddProductsToMicroScenarioScenariosMicroScenarioIdProductsPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addProductsToMicroScenarioScenariosMicroScenarioIdProductsPost
        >
      >,
      TError,
      { scenarioId: number; data: number[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addProductsToMicroScenarioScenariosMicroScenarioIdProductsPost
      >
    >,
    TError,
    { scenarioId: number; data: number[] },
    TContext
  > => {
    const mutationOptions =
      getAddProductsToMicroScenarioScenariosMicroScenarioIdProductsPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Delete All Products
 */
export const deleteAllProductsScenariosMicroScenarioIdProductsDelete = (
  scenarioId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    { url: `/scenarios/micro/${scenarioId}/products`, method: "DELETE" },
    options,
  );
};

export const getDeleteAllProductsScenariosMicroScenarioIdProductsDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteAllProductsScenariosMicroScenarioIdProductsDelete
        >
      >,
      TError,
      { scenarioId: number },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteAllProductsScenariosMicroScenarioIdProductsDelete>
    >,
    TError,
    { scenarioId: number },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteAllProductsScenariosMicroScenarioIdProductsDelete
        >
      >,
      { scenarioId: number }
    > = (props) => {
      const { scenarioId } = props ?? {};

      return deleteAllProductsScenariosMicroScenarioIdProductsDelete(
        scenarioId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteAllProductsScenariosMicroScenarioIdProductsDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteAllProductsScenariosMicroScenarioIdProductsDelete>
    >
  >;

export type DeleteAllProductsScenariosMicroScenarioIdProductsDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete All Products
 */
export const useDeleteAllProductsScenariosMicroScenarioIdProductsDelete = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteAllProductsScenariosMicroScenarioIdProductsDelete>
    >,
    TError,
    { scenarioId: number },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteAllProductsScenariosMicroScenarioIdProductsDelete>
  >,
  TError,
  { scenarioId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteAllProductsScenariosMicroScenarioIdProductsDeleteMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

/**
 * @summary Reorder Products
 */
export const reorderProductsScenariosMicroScenarioIdProductsOrderPut = (
  scenarioId: number,
  sKUProductPosition: SKUProductPosition[],
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<Product[]>(
    {
      url: `/scenarios/micro/${scenarioId}/products/order`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: sKUProductPosition,
    },
    options,
  );
};

export const getReorderProductsScenariosMicroScenarioIdProductsOrderPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderProductsScenariosMicroScenarioIdProductsOrderPut
        >
      >,
      TError,
      { scenarioId: number; data: SKUProductPosition[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof reorderProductsScenariosMicroScenarioIdProductsOrderPut>
    >,
    TError,
    { scenarioId: number; data: SKUProductPosition[] },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderProductsScenariosMicroScenarioIdProductsOrderPut
        >
      >,
      { scenarioId: number; data: SKUProductPosition[] }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return reorderProductsScenariosMicroScenarioIdProductsOrderPut(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderProductsScenariosMicroScenarioIdProductsOrderPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof reorderProductsScenariosMicroScenarioIdProductsOrderPut>
    >
  >;
export type ReorderProductsScenariosMicroScenarioIdProductsOrderPutMutationBody =
  SKUProductPosition[];
export type ReorderProductsScenariosMicroScenarioIdProductsOrderPutMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Products
 */
export const useReorderProductsScenariosMicroScenarioIdProductsOrderPut = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof reorderProductsScenariosMicroScenarioIdProductsOrderPut>
    >,
    TError,
    { scenarioId: number; data: SKUProductPosition[] },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof reorderProductsScenariosMicroScenarioIdProductsOrderPut>
  >,
  TError,
  { scenarioId: number; data: SKUProductPosition[] },
  TContext
> => {
  const mutationOptions =
    getReorderProductsScenariosMicroScenarioIdProductsOrderPutMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

/**
 * @summary Copy Adjustments To All Products
 */
export const copyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPost =
  (
    scenarioId: number,
    productGuid: string,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMicroScenarioDto>(
      {
        url: `/scenarios/micro/${scenarioId}/products/${productGuid}/copy-to-all`,
        method: "POST",
      },
      options,
    );
  };

export const getCopyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof copyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPost
        >
      >,
      TError,
      { scenarioId: number; productGuid: string },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof copyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPost
      >
    >,
    TError,
    { scenarioId: number; productGuid: string },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof copyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPost
        >
      >,
      { scenarioId: number; productGuid: string }
    > = (props) => {
      const { scenarioId, productGuid } = props ?? {};

      return copyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPost(
        scenarioId,
        productGuid,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CopyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof copyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPost
      >
    >
  >;

export type CopyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPostMutationError =
  HTTPValidationError;

/**
 * @summary Copy Adjustments To All Products
 */
export const useCopyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof copyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPost
        >
      >,
      TError,
      { scenarioId: number; productGuid: string },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof copyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPost
      >
    >,
    TError,
    { scenarioId: number; productGuid: string },
    TContext
  > => {
    const mutationOptions =
      getCopyAdjustmentsToAllProductsScenariosMicroScenarioIdProductsProductGuidCopyToAllPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get All Micro Scenarios
 */
export const getAllMicroScenariosScenariosMicroGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ListMicroScenarioDto[]>(
    { url: `/scenarios/micro`, method: "GET" },
    options,
  );
};

export const getGetAllMicroScenariosScenariosMicroGetQueryKey = () => {
  return [`/scenarios/micro`] as const;
};

export const getGetAllMicroScenariosScenariosMicroGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAllMicroScenariosScenariosMicroGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>
  > = () => getAllMicroScenariosScenariosMicroGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllMicroScenariosScenariosMicroGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>
>;
export type GetAllMicroScenariosScenariosMicroGetQueryError = unknown;

export function useGetAllMicroScenariosScenariosMicroGet<
  TData = Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllMicroScenariosScenariosMicroGet<
  TData = Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllMicroScenariosScenariosMicroGet<
  TData = Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get All Micro Scenarios
 */

export function useGetAllMicroScenariosScenariosMicroGet<
  TData = Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMicroScenariosScenariosMicroGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAllMicroScenariosScenariosMicroGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Micro Scenario
 */
export const createMicroScenarioScenariosMicroPost = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMicroScenarioDto>(
    { url: `/scenarios/micro`, method: "POST" },
    options,
  );
};

export const getCreateMicroScenarioScenariosMicroPostMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMicroScenarioScenariosMicroPost>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMicroScenarioScenariosMicroPost>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMicroScenarioScenariosMicroPost>>,
    void
  > = () => {
    return createMicroScenarioScenariosMicroPost(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMicroScenarioScenariosMicroPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMicroScenarioScenariosMicroPost>>
>;

export type CreateMicroScenarioScenariosMicroPostMutationError = unknown;

/**
 * @summary Create Micro Scenario
 */
export const useCreateMicroScenarioScenariosMicroPost = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMicroScenarioScenariosMicroPost>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMicroScenarioScenariosMicroPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getCreateMicroScenarioScenariosMicroPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Micro Scenario By Id
 */
export const getMicroScenarioByIdScenariosMicroScenarioIdGet = (
  scenarioId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMicroScenarioDto>(
    { url: `/scenarios/micro/${scenarioId}`, method: "GET" },
    options,
  );
};

export const getGetMicroScenarioByIdScenariosMicroScenarioIdGetQueryKey = (
  scenarioId: number,
) => {
  return [`/scenarios/micro/${scenarioId}`] as const;
};

export const getGetMicroScenarioByIdScenariosMicroScenarioIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMicroScenarioByIdScenariosMicroScenarioIdGetQueryKey(scenarioId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>>
  > = () =>
    getMicroScenarioByIdScenariosMicroScenarioIdGet(scenarioId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!scenarioId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMicroScenarioByIdScenariosMicroScenarioIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>>
  >;
export type GetMicroScenarioByIdScenariosMicroScenarioIdGetQueryError =
  HTTPValidationError;

export function useGetMicroScenarioByIdScenariosMicroScenarioIdGet<
  TData = Awaited<
    ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMicroScenarioByIdScenariosMicroScenarioIdGet<
  TData = Awaited<
    ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMicroScenarioByIdScenariosMicroScenarioIdGet<
  TData = Awaited<
    ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Micro Scenario By Id
 */

export function useGetMicroScenarioByIdScenariosMicroScenarioIdGet<
  TData = Awaited<
    ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMicroScenarioByIdScenariosMicroScenarioIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMicroScenarioByIdScenariosMicroScenarioIdGetQueryOptions(
      scenarioId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Micro Scenario Details
 */
export const updateMicroScenarioDetailsScenariosMicroScenarioIdPatch = (
  scenarioId: number,
  updateScenarioValues: UpdateScenarioValues,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMicroScenarioDto>(
    {
      url: `/scenarios/micro/${scenarioId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateScenarioValues,
    },
    options,
  );
};

export const getUpdateMicroScenarioDetailsScenariosMicroScenarioIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateMicroScenarioDetailsScenariosMicroScenarioIdPatch
        >
      >,
      TError,
      { scenarioId: number; data: UpdateScenarioValues },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateMicroScenarioDetailsScenariosMicroScenarioIdPatch>
    >,
    TError,
    { scenarioId: number; data: UpdateScenarioValues },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateMicroScenarioDetailsScenariosMicroScenarioIdPatch
        >
      >,
      { scenarioId: number; data: UpdateScenarioValues }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return updateMicroScenarioDetailsScenariosMicroScenarioIdPatch(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateMicroScenarioDetailsScenariosMicroScenarioIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateMicroScenarioDetailsScenariosMicroScenarioIdPatch>
    >
  >;
export type UpdateMicroScenarioDetailsScenariosMicroScenarioIdPatchMutationBody =
  UpdateScenarioValues;
export type UpdateMicroScenarioDetailsScenariosMicroScenarioIdPatchMutationError =
  HTTPValidationError;

/**
 * @summary Update Micro Scenario Details
 */
export const useUpdateMicroScenarioDetailsScenariosMicroScenarioIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof updateMicroScenarioDetailsScenariosMicroScenarioIdPatch>
    >,
    TError,
    { scenarioId: number; data: UpdateScenarioValues },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof updateMicroScenarioDetailsScenariosMicroScenarioIdPatch>
  >,
  TError,
  { scenarioId: number; data: UpdateScenarioValues },
  TContext
> => {
  const mutationOptions =
    getUpdateMicroScenarioDetailsScenariosMicroScenarioIdPatchMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Micro Scenario By Id
 */
export const deleteMicroScenarioByIdScenariosMicroScenarioIdDelete = (
  scenarioId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    { url: `/scenarios/micro/${scenarioId}`, method: "DELETE" },
    options,
  );
};

export const getDeleteMicroScenarioByIdScenariosMicroScenarioIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteMicroScenarioByIdScenariosMicroScenarioIdDelete>
      >,
      TError,
      { scenarioId: number },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteMicroScenarioByIdScenariosMicroScenarioIdDelete>
    >,
    TError,
    { scenarioId: number },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteMicroScenarioByIdScenariosMicroScenarioIdDelete>
      >,
      { scenarioId: number }
    > = (props) => {
      const { scenarioId } = props ?? {};

      return deleteMicroScenarioByIdScenariosMicroScenarioIdDelete(
        scenarioId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteMicroScenarioByIdScenariosMicroScenarioIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteMicroScenarioByIdScenariosMicroScenarioIdDelete>
    >
  >;

export type DeleteMicroScenarioByIdScenariosMicroScenarioIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Micro Scenario By Id
 */
export const useDeleteMicroScenarioByIdScenariosMicroScenarioIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteMicroScenarioByIdScenariosMicroScenarioIdDelete>
    >,
    TError,
    { scenarioId: number },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteMicroScenarioByIdScenariosMicroScenarioIdDelete>
  >,
  TError,
  { scenarioId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteMicroScenarioByIdScenariosMicroScenarioIdDeleteMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

/**
 * @summary Duplicate Micro Scenario
 */
export const duplicateMicroScenarioScenariosMicroScenarioIdDuplicatePost = (
  scenarioId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMicroScenarioDto>(
    { url: `/scenarios/micro/${scenarioId}/duplicate`, method: "POST" },
    options,
  );
};

export const getDuplicateMicroScenarioScenariosMicroScenarioIdDuplicatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof duplicateMicroScenarioScenariosMicroScenarioIdDuplicatePost
        >
      >,
      TError,
      { scenarioId: number },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof duplicateMicroScenarioScenariosMicroScenarioIdDuplicatePost
      >
    >,
    TError,
    { scenarioId: number },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof duplicateMicroScenarioScenariosMicroScenarioIdDuplicatePost
        >
      >,
      { scenarioId: number }
    > = (props) => {
      const { scenarioId } = props ?? {};

      return duplicateMicroScenarioScenariosMicroScenarioIdDuplicatePost(
        scenarioId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DuplicateMicroScenarioScenariosMicroScenarioIdDuplicatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof duplicateMicroScenarioScenariosMicroScenarioIdDuplicatePost
      >
    >
  >;

export type DuplicateMicroScenarioScenariosMicroScenarioIdDuplicatePostMutationError =
  HTTPValidationError;

/**
 * @summary Duplicate Micro Scenario
 */
export const useDuplicateMicroScenarioScenariosMicroScenarioIdDuplicatePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof duplicateMicroScenarioScenariosMicroScenarioIdDuplicatePost
      >
    >,
    TError,
    { scenarioId: number },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<
    ReturnType<
      typeof duplicateMicroScenarioScenariosMicroScenarioIdDuplicatePost
    >
  >,
  TError,
  { scenarioId: number },
  TContext
> => {
  const mutationOptions =
    getDuplicateMicroScenarioScenariosMicroScenarioIdDuplicatePostMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

/**
 * @summary Export Micro Scenario
 */
export const exportMicroScenarioScenariosMicroScenarioIdExportGet = (
  scenarioId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<unknown>(
    { url: `/scenarios/micro/${scenarioId}/export`, method: "GET" },
    options,
  );
};

export const getExportMicroScenarioScenariosMicroScenarioIdExportGetQueryKey = (
  scenarioId: number,
) => {
  return [`/scenarios/micro/${scenarioId}/export`] as const;
};

export const getExportMicroScenarioScenariosMicroScenarioIdExportGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof exportMicroScenarioScenariosMicroScenarioIdExportGet>
    >,
    TError = HTTPValidationError,
  >(
    scenarioId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exportMicroScenarioScenariosMicroScenarioIdExportGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof withCustomAxios>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExportMicroScenarioScenariosMicroScenarioIdExportGetQueryKey(
        scenarioId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof exportMicroScenarioScenariosMicroScenarioIdExportGet>
      >
    > = () =>
      exportMicroScenarioScenariosMicroScenarioIdExportGet(
        scenarioId,
        requestOptions,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!scenarioId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof exportMicroScenarioScenariosMicroScenarioIdExportGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExportMicroScenarioScenariosMicroScenarioIdExportGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof exportMicroScenarioScenariosMicroScenarioIdExportGet>
    >
  >;
export type ExportMicroScenarioScenariosMicroScenarioIdExportGetQueryError =
  HTTPValidationError;

export function useExportMicroScenarioScenariosMicroScenarioIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportMicroScenarioScenariosMicroScenarioIdExportGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportMicroScenarioScenariosMicroScenarioIdExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportMicroScenarioScenariosMicroScenarioIdExportGet
            >
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportMicroScenarioScenariosMicroScenarioIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportMicroScenarioScenariosMicroScenarioIdExportGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportMicroScenarioScenariosMicroScenarioIdExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportMicroScenarioScenariosMicroScenarioIdExportGet
            >
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportMicroScenarioScenariosMicroScenarioIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportMicroScenarioScenariosMicroScenarioIdExportGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportMicroScenarioScenariosMicroScenarioIdExportGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Micro Scenario
 */

export function useExportMicroScenarioScenariosMicroScenarioIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportMicroScenarioScenariosMicroScenarioIdExportGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportMicroScenarioScenariosMicroScenarioIdExportGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportMicroScenarioScenariosMicroScenarioIdExportGetQueryOptions(
      scenarioId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const createScenariosMicroScenarioIdAdjustmentsPost = (
  scenarioId: number,
  createMicroAdjustment: CreateMicroAdjustment[],
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMicroAdjustment[]>(
    {
      url: `/scenarios/micro/${scenarioId}/adjustments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createMicroAdjustment,
    },
    options,
  );
};

export const getCreateScenariosMicroScenarioIdAdjustmentsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScenariosMicroScenarioIdAdjustmentsPost>>,
    TError,
    { scenarioId: number; data: CreateMicroAdjustment[] },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createScenariosMicroScenarioIdAdjustmentsPost>>,
  TError,
  { scenarioId: number; data: CreateMicroAdjustment[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createScenariosMicroScenarioIdAdjustmentsPost>>,
    { scenarioId: number; data: CreateMicroAdjustment[] }
  > = (props) => {
    const { scenarioId, data } = props ?? {};

    return createScenariosMicroScenarioIdAdjustmentsPost(
      scenarioId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateScenariosMicroScenarioIdAdjustmentsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createScenariosMicroScenarioIdAdjustmentsPost>>
  >;
export type CreateScenariosMicroScenarioIdAdjustmentsPostMutationBody =
  CreateMicroAdjustment[];
export type CreateScenariosMicroScenarioIdAdjustmentsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create
 */
export const useCreateScenariosMicroScenarioIdAdjustmentsPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScenariosMicroScenarioIdAdjustmentsPost>>,
    TError,
    { scenarioId: number; data: CreateMicroAdjustment[] },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createScenariosMicroScenarioIdAdjustmentsPost>>,
  TError,
  { scenarioId: number; data: CreateMicroAdjustment[] },
  TContext
> => {
  const mutationOptions =
    getCreateScenariosMicroScenarioIdAdjustmentsPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Edit Micro Adjustments
 */
export const editMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatch = (
  scenarioId: number,
  editMicroAdjustment: EditMicroAdjustment[],
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMicroAdjustment[]>(
    {
      url: `/scenarios/micro/${scenarioId}/adjustments`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: editMicroAdjustment,
    },
    options,
  );
};

export const getEditMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof editMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatch
        >
      >,
      TError,
      { scenarioId: number; data: EditMicroAdjustment[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof editMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatch
      >
    >,
    TError,
    { scenarioId: number; data: EditMicroAdjustment[] },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof editMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatch
        >
      >,
      { scenarioId: number; data: EditMicroAdjustment[] }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return editMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatch(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EditMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof editMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatch
      >
    >
  >;
export type EditMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatchMutationBody =
  EditMicroAdjustment[];
export type EditMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatchMutationError =
  HTTPValidationError;

/**
 * @summary Edit Micro Adjustments
 */
export const useEditMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatch = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof editMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatch
      >
    >,
    TError,
    { scenarioId: number; data: EditMicroAdjustment[] },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<
    ReturnType<
      typeof editMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatch
    >
  >,
  TError,
  { scenarioId: number; data: EditMicroAdjustment[] },
  TContext
> => {
  const mutationOptions =
    getEditMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsPatchMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Micro Adjustments
 */
export const deleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDelete = (
  scenarioId: number,
  deleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDeleteBody: number[],
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    {
      url: `/scenarios/micro/${scenarioId}/adjustments`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: deleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDeleteBody,
    },
    options,
  );
};

export const getDeleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDelete
        >
      >,
      TError,
      { scenarioId: number; data: number[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDelete
      >
    >,
    TError,
    { scenarioId: number; data: number[] },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDelete
        >
      >,
      { scenarioId: number; data: number[] }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return deleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDelete(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDelete
      >
    >
  >;
export type DeleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDeleteMutationBody =
  number[];
export type DeleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Micro Adjustments
 */
export const useDeleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDelete =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDelete
        >
      >,
      TError,
      { scenarioId: number; data: number[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDelete
      >
    >,
    TError,
    { scenarioId: number; data: number[] },
    TContext
  > => {
    const mutationOptions =
      getDeleteMicroAdjustmentsScenariosMicroScenarioIdAdjustmentsDeleteMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get All Macro Scenarios
 */
export const getAllMacroScenariosScenariosMacroGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ListMacroScenarioDto[]>(
    { url: `/scenarios/macro`, method: "GET" },
    options,
  );
};

export const getGetAllMacroScenariosScenariosMacroGetQueryKey = () => {
  return [`/scenarios/macro`] as const;
};

export const getGetAllMacroScenariosScenariosMacroGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAllMacroScenariosScenariosMacroGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>
  > = () => getAllMacroScenariosScenariosMacroGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllMacroScenariosScenariosMacroGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>
>;
export type GetAllMacroScenariosScenariosMacroGetQueryError = unknown;

export function useGetAllMacroScenariosScenariosMacroGet<
  TData = Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllMacroScenariosScenariosMacroGet<
  TData = Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllMacroScenariosScenariosMacroGet<
  TData = Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get All Macro Scenarios
 */

export function useGetAllMacroScenariosScenariosMacroGet<
  TData = Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllMacroScenariosScenariosMacroGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAllMacroScenariosScenariosMacroGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Macro Scenario
 */
export const createMacroScenarioScenariosMacroPost = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMacroScenarioDto>(
    { url: `/scenarios/macro`, method: "POST" },
    options,
  );
};

export const getCreateMacroScenarioScenariosMacroPostMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMacroScenarioScenariosMacroPost>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMacroScenarioScenariosMacroPost>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMacroScenarioScenariosMacroPost>>,
    void
  > = () => {
    return createMacroScenarioScenariosMacroPost(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMacroScenarioScenariosMacroPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMacroScenarioScenariosMacroPost>>
>;

export type CreateMacroScenarioScenariosMacroPostMutationError = unknown;

/**
 * @summary Create Macro Scenario
 */
export const useCreateMacroScenarioScenariosMacroPost = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMacroScenarioScenariosMacroPost>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMacroScenarioScenariosMacroPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getCreateMacroScenarioScenariosMacroPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Macro Scenario By Id
 */
export const getMacroScenarioByIdScenariosMacroScenarioIdGet = (
  scenarioId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMacroScenarioDto>(
    { url: `/scenarios/macro/${scenarioId}`, method: "GET" },
    options,
  );
};

export const getGetMacroScenarioByIdScenariosMacroScenarioIdGetQueryKey = (
  scenarioId: number,
) => {
  return [`/scenarios/macro/${scenarioId}`] as const;
};

export const getGetMacroScenarioByIdScenariosMacroScenarioIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMacroScenarioByIdScenariosMacroScenarioIdGetQueryKey(scenarioId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>>
  > = () =>
    getMacroScenarioByIdScenariosMacroScenarioIdGet(scenarioId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!scenarioId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMacroScenarioByIdScenariosMacroScenarioIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>>
  >;
export type GetMacroScenarioByIdScenariosMacroScenarioIdGetQueryError =
  HTTPValidationError;

export function useGetMacroScenarioByIdScenariosMacroScenarioIdGet<
  TData = Awaited<
    ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMacroScenarioByIdScenariosMacroScenarioIdGet<
  TData = Awaited<
    ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMacroScenarioByIdScenariosMacroScenarioIdGet<
  TData = Awaited<
    ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Macro Scenario By Id
 */

export function useGetMacroScenarioByIdScenariosMacroScenarioIdGet<
  TData = Awaited<
    ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getMacroScenarioByIdScenariosMacroScenarioIdGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMacroScenarioByIdScenariosMacroScenarioIdGetQueryOptions(
      scenarioId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Macro Scenario
 */
export const updateMacroScenarioScenariosMacroScenarioIdPatch = (
  scenarioId: number,
  updateMacroScenarioDto: UpdateMacroScenarioDto,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMacroScenarioDto>(
    {
      url: `/scenarios/macro/${scenarioId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateMacroScenarioDto,
    },
    options,
  );
};

export const getUpdateMacroScenarioScenariosMacroScenarioIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateMacroScenarioScenariosMacroScenarioIdPatch>
      >,
      TError,
      { scenarioId: number; data: UpdateMacroScenarioDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateMacroScenarioScenariosMacroScenarioIdPatch>
    >,
    TError,
    { scenarioId: number; data: UpdateMacroScenarioDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateMacroScenarioScenariosMacroScenarioIdPatch>
      >,
      { scenarioId: number; data: UpdateMacroScenarioDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return updateMacroScenarioScenariosMacroScenarioIdPatch(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateMacroScenarioScenariosMacroScenarioIdPatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateMacroScenarioScenariosMacroScenarioIdPatch>>
  >;
export type UpdateMacroScenarioScenariosMacroScenarioIdPatchMutationBody =
  UpdateMacroScenarioDto;
export type UpdateMacroScenarioScenariosMacroScenarioIdPatchMutationError =
  HTTPValidationError;

/**
 * @summary Update Macro Scenario
 */
export const useUpdateMacroScenarioScenariosMacroScenarioIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof updateMacroScenarioScenariosMacroScenarioIdPatch>
    >,
    TError,
    { scenarioId: number; data: UpdateMacroScenarioDto },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMacroScenarioScenariosMacroScenarioIdPatch>>,
  TError,
  { scenarioId: number; data: UpdateMacroScenarioDto },
  TContext
> => {
  const mutationOptions =
    getUpdateMacroScenarioScenariosMacroScenarioIdPatchMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Macro Scenario By Id
 */
export const deleteMacroScenarioByIdScenariosMacroScenarioIdDelete = (
  scenarioId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    { url: `/scenarios/macro/${scenarioId}`, method: "DELETE" },
    options,
  );
};

export const getDeleteMacroScenarioByIdScenariosMacroScenarioIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteMacroScenarioByIdScenariosMacroScenarioIdDelete>
      >,
      TError,
      { scenarioId: number },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteMacroScenarioByIdScenariosMacroScenarioIdDelete>
    >,
    TError,
    { scenarioId: number },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteMacroScenarioByIdScenariosMacroScenarioIdDelete>
      >,
      { scenarioId: number }
    > = (props) => {
      const { scenarioId } = props ?? {};

      return deleteMacroScenarioByIdScenariosMacroScenarioIdDelete(
        scenarioId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteMacroScenarioByIdScenariosMacroScenarioIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteMacroScenarioByIdScenariosMacroScenarioIdDelete>
    >
  >;

export type DeleteMacroScenarioByIdScenariosMacroScenarioIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Macro Scenario By Id
 */
export const useDeleteMacroScenarioByIdScenariosMacroScenarioIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteMacroScenarioByIdScenariosMacroScenarioIdDelete>
    >,
    TError,
    { scenarioId: number },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteMacroScenarioByIdScenariosMacroScenarioIdDelete>
  >,
  TError,
  { scenarioId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteMacroScenarioByIdScenariosMacroScenarioIdDeleteMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

/**
 * @summary Process Filter View For Macro Scenario
 */
export const processFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPost =
  (
    scenarioId: number,
    processFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPostBody: number[],
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<MacroScenarioFilterView>(
      {
        url: `/scenarios/macro/${scenarioId}/filter-view`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: processFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPostBody,
      },
      options,
    );
  };

export const getProcessFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof processFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPost
        >
      >,
      TError,
      { scenarioId: number; data: number[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof processFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPost
      >
    >,
    TError,
    { scenarioId: number; data: number[] },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof processFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPost
        >
      >,
      { scenarioId: number; data: number[] }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return processFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ProcessFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof processFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPost
      >
    >
  >;
export type ProcessFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPostMutationBody =
  number[];
export type ProcessFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPostMutationError =
  HTTPValidationError;

/**
 * @summary Process Filter View For Macro Scenario
 */
export const useProcessFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof processFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPost
        >
      >,
      TError,
      { scenarioId: number; data: number[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof processFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPost
      >
    >,
    TError,
    { scenarioId: number; data: number[] },
    TContext
  > => {
    const mutationOptions =
      getProcessFilterViewForMacroScenarioScenariosMacroScenarioIdFilterViewPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Duplicate Macro Scenario
 */
export const duplicateMacroScenarioScenariosMacroScenarioIdDuplicatePost = (
  scenarioId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMacroScenarioDto>(
    { url: `/scenarios/macro/${scenarioId}/duplicate`, method: "POST" },
    options,
  );
};

export const getDuplicateMacroScenarioScenariosMacroScenarioIdDuplicatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof duplicateMacroScenarioScenariosMacroScenarioIdDuplicatePost
        >
      >,
      TError,
      { scenarioId: number },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof duplicateMacroScenarioScenariosMacroScenarioIdDuplicatePost
      >
    >,
    TError,
    { scenarioId: number },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof duplicateMacroScenarioScenariosMacroScenarioIdDuplicatePost
        >
      >,
      { scenarioId: number }
    > = (props) => {
      const { scenarioId } = props ?? {};

      return duplicateMacroScenarioScenariosMacroScenarioIdDuplicatePost(
        scenarioId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DuplicateMacroScenarioScenariosMacroScenarioIdDuplicatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof duplicateMacroScenarioScenariosMacroScenarioIdDuplicatePost
      >
    >
  >;

export type DuplicateMacroScenarioScenariosMacroScenarioIdDuplicatePostMutationError =
  HTTPValidationError;

/**
 * @summary Duplicate Macro Scenario
 */
export const useDuplicateMacroScenarioScenariosMacroScenarioIdDuplicatePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof duplicateMacroScenarioScenariosMacroScenarioIdDuplicatePost
      >
    >,
    TError,
    { scenarioId: number },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<
    ReturnType<
      typeof duplicateMacroScenarioScenariosMacroScenarioIdDuplicatePost
    >
  >,
  TError,
  { scenarioId: number },
  TContext
> => {
  const mutationOptions =
    getDuplicateMacroScenarioScenariosMacroScenarioIdDuplicatePostMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

/**
 * @summary Generate Macro Scenario Emissions Export
 */
export const generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet =
  (scenarioId: number, options?: SecondParameter<typeof withCustomAxios>) => {
    return withCustomAxios<unknown>(
      { url: `/scenarios/macro/${scenarioId}/export`, method: "GET" },
      options,
    );
  };

export const getGenerateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGetQueryKey =
  (scenarioId: number) => {
    return [`/scenarios/macro/${scenarioId}/export`] as const;
  };

export const getGenerateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
      >
    >,
    TError = HTTPValidationError,
  >(
    scenarioId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof withCustomAxios>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGenerateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGetQueryKey(
        scenarioId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
        >
      >
    > = () =>
      generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet(
        scenarioId,
        requestOptions,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!scenarioId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GenerateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
      >
    >
  >;
export type GenerateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGetQueryError =
  HTTPValidationError;

export function useGenerateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet<
  TData = Awaited<
    ReturnType<
      typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
    >
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
            >
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGenerateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet<
  TData = Awaited<
    ReturnType<
      typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
    >
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
            >
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGenerateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet<
  TData = Awaited<
    ReturnType<
      typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
    >
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Generate Macro Scenario Emissions Export
 */

export function useGenerateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet<
  TData = Awaited<
    ReturnType<
      typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
    >
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof generateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGenerateMacroScenarioEmissionsExportScenariosMacroScenarioIdExportGetQueryOptions(
      scenarioId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get All
 */
export const getAllScenariosMacroScenarioIdAdjustmentsGet = (
  scenarioId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<MacroScenarioAdjustmentOverview[]>(
    { url: `/scenarios/macro/${scenarioId}/adjustments`, method: "GET" },
    options,
  );
};

export const getGetAllScenariosMacroScenarioIdAdjustmentsGetQueryKey = (
  scenarioId: number,
) => {
  return [`/scenarios/macro/${scenarioId}/adjustments`] as const;
};

export const getGetAllScenariosMacroScenarioIdAdjustmentsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
  >,
  TError = void | HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAllScenariosMacroScenarioIdAdjustmentsGetQueryKey(scenarioId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>>
  > = () =>
    getAllScenariosMacroScenarioIdAdjustmentsGet(scenarioId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!scenarioId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllScenariosMacroScenarioIdAdjustmentsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>>
  >;
export type GetAllScenariosMacroScenarioIdAdjustmentsGetQueryError =
  void | HTTPValidationError;

export function useGetAllScenariosMacroScenarioIdAdjustmentsGet<
  TData = Awaited<
    ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
  >,
  TError = void | HTTPValidationError,
>(
  scenarioId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllScenariosMacroScenarioIdAdjustmentsGet<
  TData = Awaited<
    ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
  >,
  TError = void | HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllScenariosMacroScenarioIdAdjustmentsGet<
  TData = Awaited<
    ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
  >,
  TError = void | HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get All
 */

export function useGetAllScenariosMacroScenarioIdAdjustmentsGet<
  TData = Awaited<
    ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
  >,
  TError = void | HTTPValidationError,
>(
  scenarioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAllScenariosMacroScenarioIdAdjustmentsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAllScenariosMacroScenarioIdAdjustmentsGetQueryOptions(
      scenarioId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get By Id
 */
export const getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet = (
  scenarioId: number,
  adjustmentId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<ViewMacroScenarioAdjustment>(
    {
      url: `/scenarios/macro/${scenarioId}/adjustments/${adjustmentId}`,
      method: "GET",
    },
    options,
  );
};

export const getGetByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGetQueryKey =
  (scenarioId: number, adjustmentId: number) => {
    return [
      `/scenarios/macro/${scenarioId}/adjustments/${adjustmentId}`,
    ] as const;
  };

export const getGetByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
      >
    >,
    TError = HTTPValidationError,
  >(
    scenarioId: number,
    adjustmentId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof withCustomAxios>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGetQueryKey(
        scenarioId,
        adjustmentId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
        >
      >
    > = () =>
      getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet(
        scenarioId,
        adjustmentId,
        requestOptions,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(scenarioId && adjustmentId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
      >
    >
  >;
export type GetByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGetQueryError =
  HTTPValidationError;

export function useGetByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet<
  TData = Awaited<
    ReturnType<typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  adjustmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
            >
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet<
  TData = Awaited<
    ReturnType<typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  adjustmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
            >
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet<
  TData = Awaited<
    ReturnType<typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  adjustmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get By Id
 */

export function useGetByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet<
  TData = Awaited<
    ReturnType<typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet>
  >,
  TError = HTTPValidationError,
>(
  scenarioId: number,
  adjustmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdGetQueryOptions(
      scenarioId,
      adjustmentId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Edit
 */
export const editScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatch = (
  scenarioId: number,
  adjustmentId: number,
  editMacroScenarioAdjustment: EditMacroScenarioAdjustment,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<void>(
    {
      url: `/scenarios/macro/${scenarioId}/adjustments/${adjustmentId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: editMacroScenarioAdjustment,
    },
    options,
  );
};

export const getEditScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof editScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatch
        >
      >,
      TError,
      {
        scenarioId: number;
        adjustmentId: number;
        data: EditMacroScenarioAdjustment;
      },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof editScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatch
      >
    >,
    TError,
    {
      scenarioId: number;
      adjustmentId: number;
      data: EditMacroScenarioAdjustment;
    },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof editScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatch
        >
      >,
      {
        scenarioId: number;
        adjustmentId: number;
        data: EditMacroScenarioAdjustment;
      }
    > = (props) => {
      const { scenarioId, adjustmentId, data } = props ?? {};

      return editScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatch(
        scenarioId,
        adjustmentId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EditScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof editScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatch
      >
    >
  >;
export type EditScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatchMutationBody =
  EditMacroScenarioAdjustment;
export type EditScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatchMutationError =
  HTTPValidationError;

/**
 * @summary Edit
 */
export const useEditScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof editScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatch
      >
    >,
    TError,
    {
      scenarioId: number;
      adjustmentId: number;
      data: EditMacroScenarioAdjustment;
    },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof editScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatch>
  >,
  TError,
  {
    scenarioId: number;
    adjustmentId: number;
    data: EditMacroScenarioAdjustment;
  },
  TContext
> => {
  const mutationOptions =
    getEditScenariosMacroScenarioIdAdjustmentsAdjustmentIdPatchMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

/**
 * @summary Delete By Id
 */
export const deleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDelete = (
  scenarioId: number,
  adjustmentId: number,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<unknown | void>(
    {
      url: `/scenarios/macro/${scenarioId}/adjustments/${adjustmentId}`,
      method: "DELETE",
    },
    options,
  );
};

export const getDeleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDeleteMutationOptions =
  <TError = void | HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDelete
        >
      >,
      TError,
      { scenarioId: number; adjustmentId: number },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDelete
      >
    >,
    TError,
    { scenarioId: number; adjustmentId: number },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDelete
        >
      >,
      { scenarioId: number; adjustmentId: number }
    > = (props) => {
      const { scenarioId, adjustmentId } = props ?? {};

      return deleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDelete(
        scenarioId,
        adjustmentId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDelete
      >
    >
  >;

export type DeleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDeleteMutationError =
  void | HTTPValidationError;

/**
 * @summary Delete By Id
 */
export const useDeleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDelete =
  <TError = void | HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDelete
        >
      >,
      TError,
      { scenarioId: number; adjustmentId: number },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDelete
      >
    >,
    TError,
    { scenarioId: number; adjustmentId: number },
    TContext
  > => {
    const mutationOptions =
      getDeleteByIdScenariosMacroScenarioIdAdjustmentsAdjustmentIdDeleteMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Reorder Macro Adjustments
 */
export const reorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPut =
  (
    scenarioId: number,
    macroAdjustmentPosition: MacroAdjustmentPosition[],
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<void>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/order`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: macroAdjustmentPosition,
      },
      options,
    );
  };

export const getReorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPut
        >
      >,
      TError,
      { scenarioId: number; data: MacroAdjustmentPosition[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPut
      >
    >,
    TError,
    { scenarioId: number; data: MacroAdjustmentPosition[] },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPut
        >
      >,
      { scenarioId: number; data: MacroAdjustmentPosition[] }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return reorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPut(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPut
      >
    >
  >;
export type ReorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPutMutationBody =
  MacroAdjustmentPosition[];
export type ReorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPutMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Macro Adjustments
 */
export const useReorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPut =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPut
        >
      >,
      TError,
      { scenarioId: number; data: MacroAdjustmentPosition[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPut
      >
    >,
    TError,
    { scenarioId: number; data: MacroAdjustmentPosition[] },
    TContext
  > => {
    const mutationOptions =
      getReorderMacroAdjustmentsScenariosMacroScenarioIdAdjustmentsOrderPutMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Calculate Tonnes Of Co2 Per Adjustment
 */
export const calculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2Put =
  (scenarioId: number, options?: SecondParameter<typeof withCustomAxios>) => {
    return withCustomAxios<void>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/calculate-tonnes-of-co2`,
        method: "PUT",
      },
      options,
    );
  };

export const getCalculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2PutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof calculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2Put
        >
      >,
      TError,
      { scenarioId: number },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof calculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2Put
      >
    >,
    TError,
    { scenarioId: number },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof calculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2Put
        >
      >,
      { scenarioId: number }
    > = (props) => {
      const { scenarioId } = props ?? {};

      return calculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2Put(
        scenarioId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CalculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2PutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof calculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2Put
      >
    >
  >;

export type CalculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2PutMutationError =
  HTTPValidationError;

/**
 * @summary Calculate Tonnes Of Co2 Per Adjustment
 */
export const useCalculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2Put =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof calculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2Put
        >
      >,
      TError,
      { scenarioId: number },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof calculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2Put
      >
    >,
    TError,
    { scenarioId: number },
    TContext
  > => {
    const mutationOptions =
      getCalculateTonnesOfCo2PerAdjustmentScenariosMacroScenarioIdAdjustmentsCalculateTonnesOfCo2PutMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Ingredient Multi Weight Adjustment
 */
export const macroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPost =
  (
    scenarioId: number,
    ingredientMultiWeightMacroAdjustmentDto: IngredientMultiWeightMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/ingredients/weight/multi`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: ingredientMultiWeightMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPost
        >
      >,
      TError,
      { scenarioId: number; data: IngredientMultiWeightMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPost
      >
    >,
    TError,
    { scenarioId: number; data: IngredientMultiWeightMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPost
        >
      >,
      { scenarioId: number; data: IngredientMultiWeightMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPost
      >
    >
  >;
export type MacroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPostMutationBody =
  IngredientMultiWeightMacroAdjustmentDto;
export type MacroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Ingredient Multi Weight Adjustment
 */
export const useMacroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPost
        >
      >,
      TError,
      { scenarioId: number; data: IngredientMultiWeightMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPost
      >
    >,
    TError,
    { scenarioId: number; data: IngredientMultiWeightMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroIngredientMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightMultiPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Ingredient Specific Weight Adjustment
 */
export const macroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPost =
  (
    scenarioId: number,
    ingredientSpecificWeightMacroAdjustmentDto: IngredientSpecificWeightMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/ingredients/weight/specific`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: ingredientSpecificWeightMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPost
        >
      >,
      TError,
      { scenarioId: number; data: IngredientSpecificWeightMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPost
      >
    >,
    TError,
    { scenarioId: number; data: IngredientSpecificWeightMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPost
        >
      >,
      { scenarioId: number; data: IngredientSpecificWeightMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPost
      >
    >
  >;
export type MacroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPostMutationBody =
  IngredientSpecificWeightMacroAdjustmentDto;
export type MacroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Ingredient Specific Weight Adjustment
 */
export const useMacroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPost
        >
      >,
      TError,
      { scenarioId: number; data: IngredientSpecificWeightMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPost
      >
    >,
    TError,
    { scenarioId: number; data: IngredientSpecificWeightMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroIngredientSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsWeightSpecificPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Ingredient Ef Adjustment
 */
export const macroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPost =
  (
    scenarioId: number,
    ingredientEmissionFactorMacroAdjustmentDto: IngredientEmissionFactorMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/ingredients/emission-factor`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: ingredientEmissionFactorMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPost
        >
      >,
      TError,
      { scenarioId: number; data: IngredientEmissionFactorMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPost
      >
    >,
    TError,
    { scenarioId: number; data: IngredientEmissionFactorMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPost
        >
      >,
      { scenarioId: number; data: IngredientEmissionFactorMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPost
      >
    >
  >;
export type MacroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPostMutationBody =
  IngredientEmissionFactorMacroAdjustmentDto;
export type MacroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Ingredient Ef Adjustment
 */
export const useMacroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPost
        >
      >,
      TError,
      { scenarioId: number; data: IngredientEmissionFactorMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPost
      >
    >,
    TError,
    { scenarioId: number; data: IngredientEmissionFactorMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroIngredientEfAdjustmentScenariosMacroScenarioIdAdjustmentsIngredientsEmissionFactorPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Packaging Multi Weight Adjustment
 */
export const macroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPost =
  (
    scenarioId: number,
    packagingMultiWeightMacroAdjustmentDto: PackagingMultiWeightMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/packaging/weight/multi`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: packagingMultiWeightMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingMultiWeightMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingMultiWeightMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPost
        >
      >,
      { scenarioId: number; data: PackagingMultiWeightMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPost
      >
    >
  >;
export type MacroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPostMutationBody =
  PackagingMultiWeightMacroAdjustmentDto;
export type MacroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Packaging Multi Weight Adjustment
 */
export const useMacroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingMultiWeightMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingMultiWeightMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroPackagingMultiWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightMultiPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Packaging Specific Weight Adjustment
 */
export const macroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPost =
  (
    scenarioId: number,
    packagingSpecificWeightMacroAdjustmentDto: PackagingSpecificWeightMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/packaging/weight/specific`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: packagingSpecificWeightMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingSpecificWeightMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingSpecificWeightMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPost
        >
      >,
      { scenarioId: number; data: PackagingSpecificWeightMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPost
      >
    >
  >;
export type MacroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPostMutationBody =
  PackagingSpecificWeightMacroAdjustmentDto;
export type MacroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Packaging Specific Weight Adjustment
 */
export const useMacroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingSpecificWeightMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingSpecificWeightMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroPackagingSpecificWeightAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingWeightSpecificPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Packaging Recycled Content Adjustment
 */
export const macroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPost =
  (
    scenarioId: number,
    packagingRecycledContentMacroAdjustmentDto: PackagingRecycledContentMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/packaging/recycled-content`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: packagingRecycledContentMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingRecycledContentMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingRecycledContentMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPost
        >
      >,
      { scenarioId: number; data: PackagingRecycledContentMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPost
      >
    >
  >;
export type MacroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPostMutationBody =
  PackagingRecycledContentMacroAdjustmentDto;
export type MacroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Packaging Recycled Content Adjustment
 */
export const useMacroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingRecycledContentMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingRecycledContentMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroPackagingRecycledContentAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecycledContentPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Packaging Net Loss Rate Adjustment
 */
export const macroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePost =
  (
    scenarioId: number,
    packagingNetLossRateMacroAdjustmentDto: PackagingNetLossRateMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/packaging/net-loss-rate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: packagingNetLossRateMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingNetLossRateMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingNetLossRateMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePost
        >
      >,
      { scenarioId: number; data: PackagingNetLossRateMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePost
      >
    >
  >;
export type MacroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePostMutationBody =
  PackagingNetLossRateMacroAdjustmentDto;
export type MacroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Packaging Net Loss Rate Adjustment
 */
export const useMacroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingNetLossRateMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingNetLossRateMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroPackagingNetLossRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingNetLossRatePostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Packaging Recovery Rate Adjustment
 */
export const macroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePost =
  (
    scenarioId: number,
    packagingRecoveryRateMacroAdjustmentDto: PackagingRecoveryRateMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/packaging/recovery-rate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: packagingRecoveryRateMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingRecoveryRateMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingRecoveryRateMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePost
        >
      >,
      { scenarioId: number; data: PackagingRecoveryRateMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePost
      >
    >
  >;
export type MacroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePostMutationBody =
  PackagingRecoveryRateMacroAdjustmentDto;
export type MacroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Packaging Recovery Rate Adjustment
 */
export const useMacroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingRecoveryRateMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingRecoveryRateMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroPackagingRecoveryRateAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingRecoveryRatePostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Packaging Ef Adjustment
 */
export const macroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPost =
  (
    scenarioId: number,
    packagingEmissionFactorMacroAdjustmentDto: PackagingEmissionFactorMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/packaging/emission-factor`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: packagingEmissionFactorMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingEmissionFactorMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingEmissionFactorMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPost
        >
      >,
      { scenarioId: number; data: PackagingEmissionFactorMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPost
      >
    >
  >;
export type MacroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPostMutationBody =
  PackagingEmissionFactorMacroAdjustmentDto;
export type MacroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Packaging Ef Adjustment
 */
export const useMacroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPost
        >
      >,
      TError,
      { scenarioId: number; data: PackagingEmissionFactorMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPost
      >
    >,
    TError,
    { scenarioId: number; data: PackagingEmissionFactorMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroPackagingEfAdjustmentScenariosMacroScenarioIdAdjustmentsPackagingEmissionFactorPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Manufacturing Eur Adjustment
 */
export const macroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPost =
  (
    scenarioId: number,
    manufacturingEurMacroAdjustmentDto: ManufacturingEurMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/manufacturing/eur`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: manufacturingEurMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPost
        >
      >,
      TError,
      { scenarioId: number; data: ManufacturingEurMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPost
      >
    >,
    TError,
    { scenarioId: number; data: ManufacturingEurMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPost
        >
      >,
      { scenarioId: number; data: ManufacturingEurMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPost
      >
    >
  >;
export type MacroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPostMutationBody =
  ManufacturingEurMacroAdjustmentDto;
export type MacroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Manufacturing Eur Adjustment
 */
export const useMacroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPost
        >
      >,
      TError,
      { scenarioId: number; data: ManufacturingEurMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPost
      >
    >,
    TError,
    { scenarioId: number; data: ManufacturingEurMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroManufacturingEurAdjustmentScenariosMacroScenarioIdAdjustmentsManufacturingEurPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Manufacturing Source Mix Ef
 */
export const macroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPost =
  (
    scenarioId: number,
    manufacturingSourceMixEfMacroAdjustmentDto: ManufacturingSourceMixEfMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/manufacturing/source-mix-ef`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: manufacturingSourceMixEfMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPost
        >
      >,
      TError,
      { scenarioId: number; data: ManufacturingSourceMixEfMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPost
      >
    >,
    TError,
    { scenarioId: number; data: ManufacturingSourceMixEfMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPost
        >
      >,
      { scenarioId: number; data: ManufacturingSourceMixEfMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPost
      >
    >
  >;
export type MacroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPostMutationBody =
  ManufacturingSourceMixEfMacroAdjustmentDto;
export type MacroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Manufacturing Source Mix Ef
 */
export const useMacroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPost
        >
      >,
      TError,
      { scenarioId: number; data: ManufacturingSourceMixEfMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPost
      >
    >,
    TError,
    { scenarioId: number; data: ManufacturingSourceMixEfMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroManufacturingSourceMixEfScenariosMacroScenarioIdAdjustmentsManufacturingSourceMixEfPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Logistics Distance Travelled Adjustment
 */
export const macroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPost =
  (
    scenarioId: number,
    logisticsDistanceMacroAdjustmentDto: LogisticsDistanceMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/logistics/distance-travelled`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: logisticsDistanceMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPost
        >
      >,
      TError,
      { scenarioId: number; data: LogisticsDistanceMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPost
      >
    >,
    TError,
    { scenarioId: number; data: LogisticsDistanceMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPost
        >
      >,
      { scenarioId: number; data: LogisticsDistanceMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPost
      >
    >
  >;
export type MacroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPostMutationBody =
  LogisticsDistanceMacroAdjustmentDto;
export type MacroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Logistics Distance Travelled Adjustment
 */
export const useMacroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPost
        >
      >,
      TError,
      { scenarioId: number; data: LogisticsDistanceMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPost
      >
    >,
    TError,
    { scenarioId: number; data: LogisticsDistanceMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroLogisticsDistanceTravelledAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsDistanceTravelledPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Logistics Road Vehicle Mix Ef Adjustment
 */
export const macroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPost =
  (
    scenarioId: number,
    logisticsRoadVehicleMixEfMacroAdjustmentDto: LogisticsRoadVehicleMixEfMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/logistics/road-vehicle-mix-ef`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: logisticsRoadVehicleMixEfMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPost
        >
      >,
      TError,
      { scenarioId: number; data: LogisticsRoadVehicleMixEfMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPost
      >
    >,
    TError,
    { scenarioId: number; data: LogisticsRoadVehicleMixEfMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPost
        >
      >,
      { scenarioId: number; data: LogisticsRoadVehicleMixEfMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPost
      >
    >
  >;
export type MacroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPostMutationBody =
  LogisticsRoadVehicleMixEfMacroAdjustmentDto;
export type MacroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Logistics Road Vehicle Mix Ef Adjustment
 */
export const useMacroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPost
        >
      >,
      TError,
      { scenarioId: number; data: LogisticsRoadVehicleMixEfMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPost
      >
    >,
    TError,
    { scenarioId: number; data: LogisticsRoadVehicleMixEfMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroLogisticsRoadVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsRoadVehicleMixEfPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Logistics Other Vehicle Mix Ef Adjustment
 */
export const macroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPost =
  (
    scenarioId: number,
    logisticsOtherVehicleMixEfMacroAdjustmentDto: LogisticsOtherVehicleMixEfMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/logistics/other-vehicle-mix-ef`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: logisticsOtherVehicleMixEfMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPost
        >
      >,
      TError,
      {
        scenarioId: number;
        data: LogisticsOtherVehicleMixEfMacroAdjustmentDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPost
      >
    >,
    TError,
    { scenarioId: number; data: LogisticsOtherVehicleMixEfMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPost
        >
      >,
      { scenarioId: number; data: LogisticsOtherVehicleMixEfMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPost
      >
    >
  >;
export type MacroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPostMutationBody =
  LogisticsOtherVehicleMixEfMacroAdjustmentDto;
export type MacroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Logistics Other Vehicle Mix Ef Adjustment
 */
export const useMacroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPost
        >
      >,
      TError,
      {
        scenarioId: number;
        data: LogisticsOtherVehicleMixEfMacroAdjustmentDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPost
      >
    >,
    TError,
    { scenarioId: number; data: LogisticsOtherVehicleMixEfMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroLogisticsOtherVehicleMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsLogisticsOtherVehicleMixEfPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Cde Energy Mix Ef Adjustment
 */
export const macroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPost =
  (
    scenarioId: number,
    cdeEnergyMixEfMacroAdjustmentDto: CdeEnergyMixEfMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/cde/energy-mix-ef`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: cdeEnergyMixEfMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPost
        >
      >,
      TError,
      { scenarioId: number; data: CdeEnergyMixEfMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPost
      >
    >,
    TError,
    { scenarioId: number; data: CdeEnergyMixEfMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPost
        >
      >,
      { scenarioId: number; data: CdeEnergyMixEfMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPost
      >
    >
  >;
export type MacroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPostMutationBody =
  CdeEnergyMixEfMacroAdjustmentDto;
export type MacroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Cde Energy Mix Ef Adjustment
 */
export const useMacroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPost
        >
      >,
      TError,
      { scenarioId: number; data: CdeEnergyMixEfMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPost
      >
    >,
    TError,
    { scenarioId: number; data: CdeEnergyMixEfMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroCdeEnergyMixEfAdjustmentScenariosMacroScenarioIdAdjustmentsCdeEnergyMixEfPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Cde Fleet Breakdown Adjustment
 */
export const macroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPost =
  (
    scenarioId: number,
    cdeFleetBreakdownMacroAdjustmentDto: CdeFleetBreakdownMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/cde/fleet-breakdown`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: cdeFleetBreakdownMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPost
        >
      >,
      TError,
      { scenarioId: number; data: CdeFleetBreakdownMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPost
      >
    >,
    TError,
    { scenarioId: number; data: CdeFleetBreakdownMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPost
        >
      >,
      { scenarioId: number; data: CdeFleetBreakdownMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPost
      >
    >
  >;
export type MacroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPostMutationBody =
  CdeFleetBreakdownMacroAdjustmentDto;
export type MacroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Cde Fleet Breakdown Adjustment
 */
export const useMacroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPost
        >
      >,
      TError,
      { scenarioId: number; data: CdeFleetBreakdownMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPost
      >
    >,
    TError,
    { scenarioId: number; data: CdeFleetBreakdownMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroCdeFleetBreakdownAdjustmentScenariosMacroScenarioIdAdjustmentsCdeFleetBreakdownPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Sales Mix Sales Growth Adjustment
 */
export const macroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPost =
  (
    scenarioId: number,
    salesMixSalesGrowthMacroAdjustmentDto: SalesMixSalesGrowthMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/sales-mix/sales-growth`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: salesMixSalesGrowthMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPost
        >
      >,
      TError,
      { scenarioId: number; data: SalesMixSalesGrowthMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPost
      >
    >,
    TError,
    { scenarioId: number; data: SalesMixSalesGrowthMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPost
        >
      >,
      { scenarioId: number; data: SalesMixSalesGrowthMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPost
      >
    >
  >;
export type MacroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPostMutationBody =
  SalesMixSalesGrowthMacroAdjustmentDto;
export type MacroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Sales Mix Sales Growth Adjustment
 */
export const useMacroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPost
        >
      >,
      TError,
      { scenarioId: number; data: SalesMixSalesGrowthMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPost
      >
    >,
    TError,
    { scenarioId: number; data: SalesMixSalesGrowthMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroSalesMixSalesGrowthAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixSalesGrowthPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Sales Mix Category Mix Adjustment
 */
export const macroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPost =
  (
    scenarioId: number,
    salesMixCategoryMixMacroAdjustmentDto: SalesMixCategoryMixMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/sales-mix/category-mix`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: salesMixCategoryMixMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPost
        >
      >,
      TError,
      { scenarioId: number; data: SalesMixCategoryMixMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPost
      >
    >,
    TError,
    { scenarioId: number; data: SalesMixCategoryMixMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPost
        >
      >,
      { scenarioId: number; data: SalesMixCategoryMixMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPost
      >
    >
  >;
export type MacroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPostMutationBody =
  SalesMixCategoryMixMacroAdjustmentDto;
export type MacroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Sales Mix Category Mix Adjustment
 */
export const useMacroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPost
        >
      >,
      TError,
      { scenarioId: number; data: SalesMixCategoryMixMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPost
      >
    >,
    TError,
    { scenarioId: number; data: SalesMixCategoryMixMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroSalesMixCategoryMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixCategoryMixPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Sales Mix Pack Mix Adjustment
 */
export const macroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPost =
  (
    scenarioId: number,
    salesMixPackMixMacroAdjustmentDto: SalesMixPackMixMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/sales-mix/pack-mix`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: salesMixPackMixMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPost
        >
      >,
      TError,
      { scenarioId: number; data: SalesMixPackMixMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPost
      >
    >,
    TError,
    { scenarioId: number; data: SalesMixPackMixMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPost
        >
      >,
      { scenarioId: number; data: SalesMixPackMixMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPost
      >
    >
  >;
export type MacroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPostMutationBody =
  SalesMixPackMixMacroAdjustmentDto;
export type MacroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Sales Mix Pack Mix Adjustment
 */
export const useMacroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPost
        >
      >,
      TError,
      { scenarioId: number; data: SalesMixPackMixMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPost
      >
    >,
    TError,
    { scenarioId: number; data: SalesMixPackMixMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroSalesMixPackMixAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixPackMixPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Macro Sales Mix Dlz Share Adjustment
 */
export const macroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePost =
  (
    scenarioId: number,
    salesMixDlzShareMacroAdjustmentDto: SalesMixDlzShareMacroAdjustmentDto,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<ViewMacroScenarioDto>(
      {
        url: `/scenarios/macro/${scenarioId}/adjustments/sales-mix/dlz-share`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: salesMixDlzShareMacroAdjustmentDto,
      },
      options,
    );
  };

export const getMacroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePost
        >
      >,
      TError,
      { scenarioId: number; data: SalesMixDlzShareMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof macroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePost
      >
    >,
    TError,
    { scenarioId: number; data: SalesMixDlzShareMacroAdjustmentDto },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof macroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePost
        >
      >,
      { scenarioId: number; data: SalesMixDlzShareMacroAdjustmentDto }
    > = (props) => {
      const { scenarioId, data } = props ?? {};

      return macroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePost(
        scenarioId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MacroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof macroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePost
      >
    >
  >;
export type MacroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePostMutationBody =
  SalesMixDlzShareMacroAdjustmentDto;
export type MacroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePostMutationError =
  HTTPValidationError;

/**
 * @summary Macro Sales Mix Dlz Share Adjustment
 */
export const useMacroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof macroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePost
        >
      >,
      TError,
      { scenarioId: number; data: SalesMixDlzShareMacroAdjustmentDto },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof macroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePost
      >
    >,
    TError,
    { scenarioId: number; data: SalesMixDlzShareMacroAdjustmentDto },
    TContext
  > => {
    const mutationOptions =
      getMacroSalesMixDlzShareAdjustmentScenariosMacroScenarioIdAdjustmentsSalesMixDlzSharePostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Ingredients Weight
 */
export const getAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPost =
  (
    ingredientWeightAggregatedRequest: IngredientWeightAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<EntityWeightAggregate>(
      {
        url: `/scenarios/macro/adjustments/aggregated/ingredients/weight`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: ingredientWeightAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPost
        >
      >,
      TError,
      { data: IngredientWeightAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPost
      >
    >,
    TError,
    { data: IngredientWeightAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPost
        >
      >,
      { data: IngredientWeightAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPost
      >
    >
  >;
export type GetAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPostMutationBody =
  IngredientWeightAggregatedRequest;
export type GetAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Ingredients Weight
 */
export const useGetAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPost
        >
      >,
      TError,
      { data: IngredientWeightAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPost
      >
    >,
    TError,
    { data: IngredientWeightAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedIngredientsWeightScenariosMacroAdjustmentsAggregatedIngredientsWeightPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Ingredient Supplier Emission Factor
 */
export const getAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPost =
  (
    emissionFactorRequest: EmissionFactorRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<IngredientEmissionFactor[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/ingredients/emission-factor`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: emissionFactorRequest,
      },
      options,
    );
  };

export const getGetAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPost
        >
      >,
      TError,
      { data: EmissionFactorRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPost
      >
    >,
    TError,
    { data: EmissionFactorRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPost
        >
      >,
      { data: EmissionFactorRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPost
      >
    >
  >;
export type GetAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPostMutationBody =
  EmissionFactorRequest;
export type GetAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Ingredient Supplier Emission Factor
 */
export const useGetAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPost
        >
      >,
      TError,
      { data: EmissionFactorRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPost
      >
    >,
    TError,
    { data: EmissionFactorRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedIngredientSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedIngredientsEmissionFactorPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Packaging Weight
 */
export const getAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPost =
  (
    packagingWeightAggregatedRequest: PackagingWeightAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<EntityWeightAggregate>(
      {
        url: `/scenarios/macro/adjustments/aggregated/packaging/weight`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: packagingWeightAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPost
        >
      >,
      TError,
      { data: PackagingWeightAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPost
      >
    >,
    TError,
    { data: PackagingWeightAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPost
        >
      >,
      { data: PackagingWeightAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPost
      >
    >
  >;
export type GetAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPostMutationBody =
  PackagingWeightAggregatedRequest;
export type GetAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Packaging Weight
 */
export const useGetAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPost
        >
      >,
      TError,
      { data: PackagingWeightAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPost
      >
    >,
    TError,
    { data: PackagingWeightAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedPackagingWeightScenariosMacroAdjustmentsAggregatedPackagingWeightPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Packaging Weighted Avg Recycled Content
 */
export const getAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPost =
  (
    productsAggregatedRequest: ProductsAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<WeightedAverageRecycledContentAggregate>(
      {
        url: `/scenarios/macro/adjustments/aggregated/packaging/recycled-content`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: productsAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPost
        >
      >,
      TError,
      { data: ProductsAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPost
      >
    >,
    TError,
    { data: ProductsAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPost
        >
      >,
      { data: ProductsAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPost
      >
    >
  >;
export type GetAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPostMutationBody =
  ProductsAggregatedRequest;
export type GetAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Packaging Weighted Avg Recycled Content
 */
export const useGetAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPost
        >
      >,
      TError,
      { data: ProductsAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPost
      >
    >,
    TError,
    { data: ProductsAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedPackagingWeightedAvgRecycledContentScenariosMacroAdjustmentsAggregatedPackagingRecycledContentPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Packaging Weighted Avg Breakage Rate
 */
export const getAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePost =
  (
    productsAggregatedRequest: ProductsAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<WeightedAverageNetLossRateAggregate>(
      {
        url: `/scenarios/macro/adjustments/aggregated/packaging/net-loss-rate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: productsAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePost
        >
      >,
      TError,
      { data: ProductsAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePost
      >
    >,
    TError,
    { data: ProductsAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePost
        >
      >,
      { data: ProductsAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePost
      >
    >
  >;
export type GetAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePostMutationBody =
  ProductsAggregatedRequest;
export type GetAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Packaging Weighted Avg Breakage Rate
 */
export const useGetAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePost
        >
      >,
      TError,
      { data: ProductsAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePost
      >
    >,
    TError,
    { data: ProductsAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedPackagingWeightedAvgBreakageRateScenariosMacroAdjustmentsAggregatedPackagingNetLossRatePostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Packaging Weighted Avg Recovery Rate
 */
export const getAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePost =
  (
    productsAggregatedRequest: ProductsAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<CountryPackagingAverageRecoveryRate[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/packaging/recovery-rate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: productsAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePost
        >
      >,
      TError,
      { data: ProductsAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePost
      >
    >,
    TError,
    { data: ProductsAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePost
        >
      >,
      { data: ProductsAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePost
      >
    >
  >;
export type GetAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePostMutationBody =
  ProductsAggregatedRequest;
export type GetAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Packaging Weighted Avg Recovery Rate
 */
export const useGetAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePost
        >
      >,
      TError,
      { data: ProductsAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePost
      >
    >,
    TError,
    { data: ProductsAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedPackagingWeightedAvgRecoveryRateScenariosMacroAdjustmentsAggregatedPackagingRecoveryRatePostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Packaging Supplier Emission Factor
 */
export const getAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPost =
  (
    emissionFactorRequest: EmissionFactorRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<PartMaterialEmissionFactor[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/packaging/emission-factor`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: emissionFactorRequest,
      },
      options,
    );
  };

export const getGetAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPost
        >
      >,
      TError,
      { data: EmissionFactorRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPost
      >
    >,
    TError,
    { data: EmissionFactorRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPost
        >
      >,
      { data: EmissionFactorRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPost
      >
    >
  >;
export type GetAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPostMutationBody =
  EmissionFactorRequest;
export type GetAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Packaging Supplier Emission Factor
 */
export const useGetAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPost
        >
      >,
      TError,
      { data: EmissionFactorRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPost
      >
    >,
    TError,
    { data: EmissionFactorRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedPackagingSupplierEmissionFactorScenariosMacroAdjustmentsAggregatedPackagingEmissionFactorPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Manufacturing Eur
 */
export const getAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPost =
  (
    productsAggregatedRequest: ProductsAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<CountryAverageManufacturingEur[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/manufacturing/eur`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: productsAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPost
        >
      >,
      TError,
      { data: ProductsAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPost
      >
    >,
    TError,
    { data: ProductsAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPost
        >
      >,
      { data: ProductsAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPost
      >
    >
  >;
export type GetAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPostMutationBody =
  ProductsAggregatedRequest;
export type GetAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Manufacturing Eur
 */
export const useGetAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPost
        >
      >,
      TError,
      { data: ProductsAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPost
      >
    >,
    TError,
    { data: ProductsAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedManufacturingEurScenariosMacroAdjustmentsAggregatedManufacturingEurPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Manufacturing Source Mix Ef
 */
export const getAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPost =
  (
    emissionFactorRequest: EmissionFactorRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<EnergyTypeEmissionFactor[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/manufacturing/source-mix-ef`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: emissionFactorRequest,
      },
      options,
    );
  };

export const getGetAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPost
        >
      >,
      TError,
      { data: EmissionFactorRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPost
      >
    >,
    TError,
    { data: EmissionFactorRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPost
        >
      >,
      { data: EmissionFactorRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPost
      >
    >
  >;
export type GetAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPostMutationBody =
  EmissionFactorRequest;
export type GetAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Manufacturing Source Mix Ef
 */
export const useGetAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPost
        >
      >,
      TError,
      { data: EmissionFactorRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPost
      >
    >,
    TError,
    { data: EmissionFactorRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedManufacturingSourceMixEfScenariosMacroAdjustmentsAggregatedManufacturingSourceMixEfPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Distance Travelled
 */
export const getAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPost =
  (
    productsAggregatedRequest: ProductsAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<CountryAverageDistanceTravelled[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/logistics/distance-travelled`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: productsAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPost
        >
      >,
      TError,
      { data: ProductsAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPost
      >
    >,
    TError,
    { data: ProductsAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPost
        >
      >,
      { data: ProductsAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPost
      >
    >
  >;
export type GetAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPostMutationBody =
  ProductsAggregatedRequest;
export type GetAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Distance Travelled
 */
export const useGetAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPost
        >
      >,
      TError,
      { data: ProductsAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPost
      >
    >,
    TError,
    { data: ProductsAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedDistanceTravelledScenariosMacroAdjustmentsAggregatedLogisticsDistanceTravelledPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Logistics Road Vehicle Mix Ef
 */
export const getAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPost =
  (
    emissionFactorRequest: EmissionFactorRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<VehicleMixEmissionFactor[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/logistics/road-vehicle-mix-ef`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: emissionFactorRequest,
      },
      options,
    );
  };

export const getGetAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPost
        >
      >,
      TError,
      { data: EmissionFactorRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPost
      >
    >,
    TError,
    { data: EmissionFactorRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPost
        >
      >,
      { data: EmissionFactorRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPost
      >
    >
  >;
export type GetAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPostMutationBody =
  EmissionFactorRequest;
export type GetAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Logistics Road Vehicle Mix Ef
 */
export const useGetAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPost
        >
      >,
      TError,
      { data: EmissionFactorRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPost
      >
    >,
    TError,
    { data: EmissionFactorRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedLogisticsRoadVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsRoadVehicleMixEfPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Logistics Other Vehicle Mix Ef
 */
export const getAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPost =
  (
    emissionFactorRequest: EmissionFactorRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<VehicleMixEmissionFactor[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/logistics/other-vehicle-mix-ef`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: emissionFactorRequest,
      },
      options,
    );
  };

export const getGetAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPost
        >
      >,
      TError,
      { data: EmissionFactorRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPost
      >
    >,
    TError,
    { data: EmissionFactorRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPost
        >
      >,
      { data: EmissionFactorRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPost
      >
    >
  >;
export type GetAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPostMutationBody =
  EmissionFactorRequest;
export type GetAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Logistics Other Vehicle Mix Ef
 */
export const useGetAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPost
        >
      >,
      TError,
      { data: EmissionFactorRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPost
      >
    >,
    TError,
    { data: EmissionFactorRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedLogisticsOtherVehicleMixEfScenariosMacroAdjustmentsAggregatedLogisticsOtherVehicleMixEfPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Cde Energy Ef
 */
export const getAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPost =
  (
    cdeAggregatedRequest: CdeAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<CountryCdeEnergyEmissionFactor[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/cde/energy-mix-ef`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: cdeAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPost
        >
      >,
      TError,
      { data: CdeAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPost
      >
    >,
    TError,
    { data: CdeAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPost
        >
      >,
      { data: CdeAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPost
      >
    >
  >;
export type GetAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPostMutationBody =
  CdeAggregatedRequest;
export type GetAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Cde Energy Ef
 */
export const useGetAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPost
        >
      >,
      TError,
      { data: CdeAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPost
      >
    >,
    TError,
    { data: CdeAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedCdeEnergyEfScenariosMacroAdjustmentsAggregatedCdeEnergyMixEfPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Cde Fleet Breakdown
 */
export const getAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPost =
  (
    cdeFleetBreakdownAggregatedRequest: CdeFleetBreakdownAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<CountryCdeAverageEnergyConsumption[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/cde/fleet-breakdown`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: cdeFleetBreakdownAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPost
        >
      >,
      TError,
      { data: CdeFleetBreakdownAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPost
      >
    >,
    TError,
    { data: CdeFleetBreakdownAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPost
        >
      >,
      { data: CdeFleetBreakdownAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPost
      >
    >
  >;
export type GetAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPostMutationBody =
  CdeFleetBreakdownAggregatedRequest;
export type GetAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Cde Fleet Breakdown
 */
export const useGetAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPost
        >
      >,
      TError,
      { data: CdeFleetBreakdownAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPost
      >
    >,
    TError,
    { data: CdeFleetBreakdownAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedCdeFleetBreakdownScenariosMacroAdjustmentsAggregatedCdeFleetBreakdownPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Sales Growth
 */
export const getAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPost =
  (
    salesGrowthAggregatedRequest: SalesGrowthAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<CountrySalesGrowth[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/sales-mix/sales-growth`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: salesGrowthAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPost
        >
      >,
      TError,
      { data: SalesGrowthAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPost
      >
    >,
    TError,
    { data: SalesGrowthAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPost
        >
      >,
      { data: SalesGrowthAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPost
      >
    >
  >;
export type GetAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPostMutationBody =
  SalesGrowthAggregatedRequest;
export type GetAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Sales Growth
 */
export const useGetAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPost
        >
      >,
      TError,
      { data: SalesGrowthAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPost
      >
    >,
    TError,
    { data: SalesGrowthAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedSalesGrowthScenariosMacroAdjustmentsAggregatedSalesMixSalesGrowthPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Category Mix
 */
export const getAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPost =
  (
    categoryMixAggregatedRequest: CategoryMixAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<YearCategoryMix>(
      {
        url: `/scenarios/macro/adjustments/aggregated/sales-mix/category-mix`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: categoryMixAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPost
        >
      >,
      TError,
      { data: CategoryMixAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPost
      >
    >,
    TError,
    { data: CategoryMixAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPost
        >
      >,
      { data: CategoryMixAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPost
      >
    >
  >;
export type GetAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPostMutationBody =
  CategoryMixAggregatedRequest;
export type GetAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Category Mix
 */
export const useGetAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPost
        >
      >,
      TError,
      { data: CategoryMixAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPost
      >
    >,
    TError,
    { data: CategoryMixAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedCategoryMixScenariosMacroAdjustmentsAggregatedSalesMixCategoryMixPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Pack Mix
 */
export const getAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPost =
  (
    packMixAggregatedRequest: PackMixAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<CategoryPackMix[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/sales-mix/pack-mix`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: packMixAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPost
        >
      >,
      TError,
      { data: PackMixAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPost
      >
    >,
    TError,
    { data: PackMixAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPost
        >
      >,
      { data: PackMixAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPost
      >
    >
  >;
export type GetAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPostMutationBody =
  PackMixAggregatedRequest;
export type GetAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Pack Mix
 */
export const useGetAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPost
        >
      >,
      TError,
      { data: PackMixAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPost
      >
    >,
    TError,
    { data: PackMixAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedPackMixScenariosMacroAdjustmentsAggregatedSalesMixPackMixPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Aggregated Dlz Share
 */
export const getAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePost =
  (
    dlzShareAggregatedRequest: DlzShareAggregatedRequest,
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<CategoryDlzShare[]>(
      {
        url: `/scenarios/macro/adjustments/aggregated/sales-mix/dlz-share`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: dlzShareAggregatedRequest,
      },
      options,
    );
  };

export const getGetAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePost
        >
      >,
      TError,
      { data: DlzShareAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePost
      >
    >,
    TError,
    { data: DlzShareAggregatedRequest },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePost
        >
      >,
      { data: DlzShareAggregatedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return getAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePost
      >
    >
  >;
export type GetAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePostMutationBody =
  DlzShareAggregatedRequest;
export type GetAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePostMutationError =
  HTTPValidationError;

/**
 * @summary Get Aggregated Dlz Share
 */
export const useGetAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePost
        >
      >,
      TError,
      { data: DlzShareAggregatedRequest },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePost
      >
    >,
    TError,
    { data: DlzShareAggregatedRequest },
    TContext
  > => {
    const mutationOptions =
      getGetAggregatedDlzShareScenariosMacroAdjustmentsAggregatedSalesMixDlzSharePostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Macro Filters And Filtered Rtdl
 */
export const getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet = (
  params: GetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetParams,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<MacroFiltersAndFilteredRTDL>(
    { url: `/scenarios/macro/filters`, method: "GET", params },
    options,
  );
};

export const getGetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetQueryKey =
  (params: GetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetParams) => {
    return [`/scenarios/macro/filters`, ...(params ? [params] : [])] as const;
  };

export const getGetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet>
    >,
    TError = HTTPValidationError,
  >(
    params: GetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof withCustomAxios>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet
        >
      >
    > = () =>
      getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet(
        params,
        requestOptions,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet>
    >
  >;
export type GetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetQueryError =
  HTTPValidationError;

export function useGetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet<
  TData = Awaited<
    ReturnType<typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet
            >
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet<
  TData = Awaited<
    ReturnType<typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet
            >
          >,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet<
  TData = Awaited<
    ReturnType<typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Macro Filters And Filtered Rtdl
 */

export function useGetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet<
  TData = Awaited<
    ReturnType<typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMacroFiltersAndFilteredRtdlScenariosMacroFiltersGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMacroFiltersAndFilteredRtdlScenariosMacroFiltersGetQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Macro Filters And Filtered Rtdl For Products
 */
export const getMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPost =
  (
    getMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPostBody: number[],
    options?: SecondParameter<typeof withCustomAxios>,
  ) => {
    return withCustomAxios<MacroFiltersAndFilteredRTDLForProducts>(
      {
        url: `/scenarios/macro/filters_for_products`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: getMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPostBody,
      },
      options,
    );
  };

export const getGetMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPost
        >
      >,
      TError,
      { data: number[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPost
      >
    >,
    TError,
    { data: number[] },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPost
        >
      >,
      { data: number[] }
    > = (props) => {
      const { data } = props ?? {};

      return getMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPost
      >
    >
  >;
export type GetMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPostMutationBody =
  number[];
export type GetMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Macro Filters And Filtered Rtdl For Products
 */
export const useGetMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPost
        >
      >,
      TError,
      { data: number[] },
      TContext
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPost
      >
    >,
    TError,
    { data: number[] },
    TContext
  > => {
    const mutationOptions =
      getGetMacroFiltersAndFilteredRtdlForProductsScenariosMacroFiltersForProductsPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };

/**
 * @summary Get Total Rtdl
 */
export const getTotalRtdlScenariosMacroTotalRtdlGet = (
  params: GetTotalRtdlScenariosMacroTotalRtdlGetParams,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<number>(
    { url: `/scenarios/macro/total_rtdl`, method: "GET", params },
    options,
  );
};

export const getGetTotalRtdlScenariosMacroTotalRtdlGetQueryKey = (
  params: GetTotalRtdlScenariosMacroTotalRtdlGetParams,
) => {
  return [`/scenarios/macro/total_rtdl`, ...(params ? [params] : [])] as const;
};

export const getGetTotalRtdlScenariosMacroTotalRtdlGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
  TError = HTTPValidationError,
>(
  params: GetTotalRtdlScenariosMacroTotalRtdlGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTotalRtdlScenariosMacroTotalRtdlGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>
  > = () => getTotalRtdlScenariosMacroTotalRtdlGet(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTotalRtdlScenariosMacroTotalRtdlGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>
>;
export type GetTotalRtdlScenariosMacroTotalRtdlGetQueryError =
  HTTPValidationError;

export function useGetTotalRtdlScenariosMacroTotalRtdlGet<
  TData = Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
  TError = HTTPValidationError,
>(
  params: GetTotalRtdlScenariosMacroTotalRtdlGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTotalRtdlScenariosMacroTotalRtdlGet<
  TData = Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
  TError = HTTPValidationError,
>(
  params: GetTotalRtdlScenariosMacroTotalRtdlGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTotalRtdlScenariosMacroTotalRtdlGet<
  TData = Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
  TError = HTTPValidationError,
>(
  params: GetTotalRtdlScenariosMacroTotalRtdlGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Total Rtdl
 */

export function useGetTotalRtdlScenariosMacroTotalRtdlGet<
  TData = Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
  TError = HTTPValidationError,
>(
  params: GetTotalRtdlScenariosMacroTotalRtdlGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalRtdlScenariosMacroTotalRtdlGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTotalRtdlScenariosMacroTotalRtdlGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get All Accordions
 */
export const getAllAccordionsAccordionsGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<AccordionsViewModel[]>(
    { url: `/accordions`, method: "GET" },
    options,
  );
};

export const getGetAllAccordionsAccordionsGetQueryKey = () => {
  return [`/accordions`] as const;
};

export const getGetAllAccordionsAccordionsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllAccordionsAccordionsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>
  > = () => getAllAccordionsAccordionsGet(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllAccordionsAccordionsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>
>;
export type GetAllAccordionsAccordionsGetQueryError = unknown;

export function useGetAllAccordionsAccordionsGet<
  TData = Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllAccordionsAccordionsGet<
  TData = Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllAccordionsAccordionsGet<
  TData = Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get All Accordions
 */

export function useGetAllAccordionsAccordionsGet<
  TData = Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllAccordionsAccordionsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllAccordionsAccordionsGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download Multiple Users Upload Template
 */
export const downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet = (
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  return withCustomAxios<unknown>(
    { url: `/files/user-upload-template`, method: "GET" },
    options,
  );
};

export const getDownloadMultipleUsersUploadTemplateFilesUserUploadTemplateGetQueryKey =
  () => {
    return [`/files/user-upload-template`] as const;
  };

export const getDownloadMultipleUsersUploadTemplateFilesUserUploadTemplateGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
      >
    >,
    TError = unknown,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof withCustomAxios>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDownloadMultipleUsersUploadTemplateFilesUserUploadTemplateGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
        >
      >
    > = () =>
      downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet(
        requestOptions,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DownloadMultipleUsersUploadTemplateFilesUserUploadTemplateGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
      >
    >
  >;
export type DownloadMultipleUsersUploadTemplateFilesUserUploadTemplateGetQueryError =
  unknown;

export function useDownloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet<
  TData = Awaited<
    ReturnType<
      typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
    >
  >,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
        >
      >,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<
          ReturnType<
            typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
          >
        >,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet<
  TData = Awaited<
    ReturnType<
      typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
    >
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
        >
      >,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<
          ReturnType<
            typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
          >
        >,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet<
  TData = Awaited<
    ReturnType<
      typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
    >
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
        >
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Multiple Users Upload Template
 */

export function useDownloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet<
  TData = Awaited<
    ReturnType<
      typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
    >
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadMultipleUsersUploadTemplateFilesUserUploadTemplateGet
        >
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadMultipleUsersUploadTemplateFilesUserUploadTemplateGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Issue
 */
export const createIssueIssuesPost = (
  bodyCreateIssueIssuesPost: BodyCreateIssueIssuesPost,
  options?: SecondParameter<typeof withCustomAxios>,
) => {
  const formData = new FormData();
  formData.append("title", bodyCreateIssueIssuesPost.title);
  formData.append("description", bodyCreateIssueIssuesPost.description);
  formData.append("send_copy", bodyCreateIssueIssuesPost.send_copy.toString());
  if (bodyCreateIssueIssuesPost.attachments !== undefined) {
    bodyCreateIssueIssuesPost.attachments.forEach((value) =>
      formData.append("attachments", value),
    );
  }

  return withCustomAxios<unknown>(
    {
      url: `/issues`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getCreateIssueIssuesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createIssueIssuesPost>>,
    TError,
    { data: BodyCreateIssueIssuesPost },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createIssueIssuesPost>>,
  TError,
  { data: BodyCreateIssueIssuesPost },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createIssueIssuesPost>>,
    { data: BodyCreateIssueIssuesPost }
  > = (props) => {
    const { data } = props ?? {};

    return createIssueIssuesPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateIssueIssuesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createIssueIssuesPost>>
>;
export type CreateIssueIssuesPostMutationBody = BodyCreateIssueIssuesPost;
export type CreateIssueIssuesPostMutationError = HTTPValidationError;

/**
 * @summary Create Issue
 */
export const useCreateIssueIssuesPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createIssueIssuesPost>>,
    TError,
    { data: BodyCreateIssueIssuesPost },
    TContext
  >;
  request?: SecondParameter<typeof withCustomAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createIssueIssuesPost>>,
  TError,
  { data: BodyCreateIssueIssuesPost },
  TContext
> => {
  const mutationOptions = getCreateIssueIssuesPostMutationOptions(options);

  return useMutation(mutationOptions);
};
